<script>
import Multiselect from "@vueform/multiselect";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import useVuelidate from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";
import Loader from "../components/loader";
import api from "@/axios";
import moment from "moment";
import Swal from "sweetalert2";
import { useMagicKeys, whenever } from '@vueuse/core'
import {getBaseUrl} from "@/helpers/baseUrl";
import {cubagemItem} from "@/helpers/cubagem";

export default {

  page: {
    title: "Orçamento",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Loader, Multiselect, },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      paramSugereItens: false,
      showModalSugereItens: false,
      orctoItensSugeridos: false,

      submittedPeriodo: false,
      valorTotalFinanc: 0,

      submitOrctoFinanc: false,
      showModalOrctoFinan: false,
      orctoFinanData: {},
      orctoFinansData: {},

      cotaFreteListData: {},

      loadingCotarFrete: false,
      showModalCotarFrete: false,
      showModalDesconto: false,
      messageValidacaoItem: '',
      margemBrutaOrcto: 0,

      showSelecionarEnder: false,
      showModalAuditoria: false,
      showModalTransp: false,
      showModalFrete: false,
      submitOrctoItem: false,

      loadingCliente: false,
      loadingCondPgto: false,
      loadingFormaPgto: false,
      loadingRepres: false,
      loadingPedTipo: false,
      loadingOrctoItem: false,
      loadingTransp: false,

      dtListPesqCli: null,
      dtListPesqCondPgto: null,
      dtListPesqFormaPgto: null,
      dtListPesqRepres: null,
      dtlistPesqPedTipo: null,
      dtlistPesqOrctoItem: null,
      dtListPesqTransp: null,
      dtListPesqFreteCota: null,

      showModalCliente: false,
      showModalCondPgto: false,
      showModalDataOrcamento: false,
      showModalFormaPgto: false,
      showModalRepres: false,
      showModalPedTipo: false,
      showModalOrctoItem: false,
      showModalObs: false,

      orctoData: {
        id: 0,
        status: "EL",
        formapgto: '10',
        condpgto: '10',
        cliente: '',
        tipo: '20',
        dtemissao: new Date
      },
      clienteData: null,
      condPgtoData: {
        'codigo': '10',
        'descricao': '30 / 60 Dias'
      },
      formaPgtoData: {
        'codigo': '10',
        'descricao': 'Boleto'
      },
      pedTipoData: {
        'codigo': '20',
        'descricao': 'Venda Estabelecimento'
      },
      pessoaEnderData: {},
      represData: {},
      transpData: {},
      freteCotaData: {},
      orctoItemData: {},
      orctoItensData: null,

      somaPedidosCli: 0,
      ultPedsData: null,
      errosValid: null,
      itensData: null,

      idData: 0,
      updating: true,
      title: "Editar Orçamento",
      items: [
        {
          text: "Orçamentos",
          href: "/orcamentos/list",
        },
        {
          text: "Editar Orçamento",
          active: true,
        },
      ],
      wmsos: [],
      wmsositens: []
    };
  },
  validations: {
    orctoItemData: {
      produto: {
        required: helpers.withMessage("Campo produto obrigatório, favor preencher.", required),
      },
      qtd: {
        required: helpers.withMessage("Campo quantidade obrigatório, favor preencher.", required),
      },
      vlrunitliq: {
        required: helpers.withMessage("Campo valor unitário obrigatório, favor preencher.", required),
      },
      vlrtotalliq: {
        required: helpers.withMessage("Campo valor total obrigatório, favor preencher.", required),
      },
    }
  },
  watch: {
    'orctoItemData.qtd': {
      handler() {
        this.calculaTotalItem()
      }
    },
    'orctoItemData.vlrunitliq': {
      handler() {
        this.calculaTotalItem()
      }
    },
  },

  mounted() {
    const keys = useMagicKeys()
    whenever(keys.alt_s, () => {
      if (this.orctoData.status === 'EL') {
        this.salvarOrcamento()
      }
    })
    whenever(keys.alt_i, () => {
      this.imprimirOrcamento()
    })
    whenever(keys.alt_n, () => {
      if (this.orctoData.status === 'EL') {
        this.novoProduto()
      }
    })

    console.log('mounted_orcamento_editar_0')
    let rota = this.$route.path
    // console.log(rota)
    let ultimaBarra = rota.lastIndexOf('/')
    if (ultimaBarra) {
      this.idData = parseInt(rota.substring(ultimaBarra + 1))
    }
    console.log(`idData: ${this.idData}`)

    if (this.idData > 0) {
      this.carregarDados()
    } else {
      this.title = `Criando Novo Orçamento`
      this.updating = false
      let emprAtu = localStorage.getItem('empratu')
      this.orctoData.empresa = emprAtu

      api.get(`${getBaseUrl()}api/orctodf`).then((res) => {
        console.log('res defaults')
        console.log(res)
        this.freteCotaData = res.data[0]
        this.paramSugereItens = res.data[1]
        if (this.freteCotaData && this.freteCotaData.id) {
          this.orctoData.segto = res.data[0].codigo
          this.dtListPesqFreteCota = [
            {
              'codigo': this.freteCotaData.codigo,
              'nome': this.freteCotaData.nome,
            }
          ]
        }
      })
    }

  },

  methods: {
    fecharOrcamento(){
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Fechar orçamento",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          api.get(`${getBaseUrl()}api/quitarorcto`, {
            params: {
              'iddata': this.idData
            }
          }).then((res) => {
              console.log('then fecharOrcamento')
              console.log(res.data)

              let flag = res.data.success ?? false

              if(flag){
                Swal.fire({
                  position: "top-end",
                  icon: "success",
                  text: res.data.message,
                  showCancelButton: false,
                  showConfirmButton: false,
                  timer: 2500
                }).then(() => {
                  this.atualizaPagina()
                })
              }else{
                Swal.fire({
                  position: "top-end",
                  icon: "error",
                  text: res.data.message,
                  showCancelButton: false,
                  showConfirmButton: false,
                  timer: 2500
                }).then(() => {
                  this.atualizaPagina()
                })
              }
          }).catch((e) => {
            console.log('error')
            console.log(e)
          })
        }
      })
    },


    deletarOrctoSugestao(data) {
      console.log('deletarOrctoSugestao')
      this.orctoItensSugeridos.splice(this.orctoItensSugeridos.indexOf(data), 1);
    },


    confSugestao(){
      console.log('confSugestao')
      this.showModalSugereItens = false
      this.updating = true
      this.orctoItensSugeridos.forEach((value) => {
        value['orcamento_id'] = this.idData
      });
      api.post(`${getBaseUrl()}api/orctoitens`, {
        orctoItensData: this.orctoItensSugeridos
      }).then((res) => {
        console.log('then axios')
        console.log(res)
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações salvas com sucesso!",
          showConfirmButton: false,
          timer: 2000
        })
        this.carregarDados()
      })
    },

    redirecionaPedido(idOs){
      console.log('redirecting to pedido')

      const url = this.$router.resolve({ path: `/wmsos/saidaeditarnova/${idOs}` }).href
      window.open(url, '_blank')
    },

    atualizaPagina() {
      window.location.reload();
    },

    excluirFinanc() {
      console.log('excluirFinanc')
      this.showModalOrctoFinan = false

      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,

      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/orctofinanc`, {
            params: {
              'iddata': this.orctoFinanData.id
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            this.carregarDados()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
          })

        }
      })




    },


    alteraPagamento(dataSel) {
      console.log('alteraPagamento')
      this.orctoFinanData = dataSel
      this.dtListPesqFormaPgto = [
        {
          'codigo': dataSel.formapgto,
          'descricao': dataSel.formapgtodesc
        },
      ]
      this.showModalOrctoFinan = true
    },



    novoPagamento() {
      console.log('exibirPagamentos')
      this.orctoFinanData = {}
      this.submitOrctoFinanc = false
      this.showModalOrctoFinan = true


    },



    escolherFrete(valorFrete) {
      console.log('escolherFrete')
      this.orctoData.valorfrt = valorFrete
      this.showModalCotarFrete = false
      this.salvarOrcamento()

      Swal.fire({
        position: "top-end",
        icon: "success",
        title: "Frente selecionado com sucesso!",
        showConfirmButton: false,
        timer: 1500
      }).then(() => {
        this.atualizaPagina()
      })

    },

    cotarFrete() {
      console.log('cotarFrete')
      this.showModalCotarFrete = true
      this.loadingCotarFrete = true

      api.get(`${getBaseUrl()}api/cotarfrete`, {
        params: { iddata: this.idData }
      }).then((res) => {
        console.log('res cotarFrete')
        console.log(res.data[0])

        if (!res.data['SDT_WSRetorno']) {
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: res.data[0],
            showConfirmButton: false,
            timer: 5000
          }).then(() => {
            // this.atualizaPagina()
          })
        } else {
          console.log(res.data['SDT_WSRetorno']['Resultados'])
          // console.log(res.data[0]['SDT_WSRetorno'])
          this.cotaFreteListData = res.data['SDT_WSRetorno']['Resultados']

          // ordenar array pela WSOut_Frete_Val
          this.cotaFreteListData = this.cotaFreteListData.slice().sort(function (a, b) {
            return a.WSOut_Frete_Val - b.WSOut_Frete_Val;
          })

          let menorValor = 999999
          let menorPrazo = 999999
          this.cotaFreteListData.forEach((value) => {
            if (value.WSOut_Frete_Val < menorValor) {
              menorValor = value.WSOut_Frete_Val
            }
            if (value.WSOut_Prazo_Dias < menorPrazo) {
              menorPrazo = value.WSOut_Prazo_Dias
            }

            value.WSOut_Frete_Val = parseFloat(value.WSOut_Frete_Val)

          })

          this.cotaFreteListData.forEach((value) => {
            if (value.WSOut_Frete_Val === menorValor) {
              value['menorvalor'] = true
            }
            if (value.WSOut_Prazo_Dias === menorPrazo) {
              value['menorprazo'] = true
            }
          })


          this.loadingCotarFrete = false
        }
      })
    },


    auditoria() {
      console.log('auditoria')
      this.showModalAuditoria = true
    },


    focusProdOrctoItem() {
      this.$refs.focusThis.focus()
    },


    imprimirOrcamento() {
      this.updating = true
      api.get(`${getBaseUrl()}api/orctopdf`, {
        responseType: 'blob',
        params: { iddata: this.idData }
      }).then((res) => {
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'Orcamento ' + this.idData + '.pdf');
        document.body.appendChild(fileLink);
        fileLink.click();
        this.updating = false
      })
    },

    copiarOrcamento() {
      console.log('copiarOrcamento')
      this.updating = true
      api.post(`${getBaseUrl()}api/orctocopy`, {
        'iddata': this.idData
      }).then((res) => {
        console.log('then axios copiar')
        console.log(res.data[0].id)
        //this.orctoData = res.data

        this.idData = res.data[0].id
        this.$router.replace({ path: `/orcamento/editar/${this.idData}` })
        this.carregarDados()

        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Orçamento copiado com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })
      })

    },

    copiarOrcamento02() {
      console.log('copiarOrcamento02')
      this.updating = true
      api.post(`${getBaseUrl()}api/orctocopy02`, {
        'iddata': this.idData
      }).then((res) => {
        console.log('then axios copiar')
        console.log(res.data[0].id)
        //this.orctoData = res.data

        this.idData = res.data[0].id
        this.$router.replace({ path: `/orcamento/editar/${this.idData}` })
        this.carregarDados()

        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Orçamento copiado com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })
      })

    },




    deletarOrctoItem(iditem) {
      console.log('deletarOrctoItem')
      console.log(iditem)

      if (this.orctoData.status === 'EL') {
        Swal.fire({
          position: "center",
          icon: "question",
          title: "Exclusão de Registro",
          text: "Esta operação é irreversível, tem certeza que deseja continuar?",
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
          showConfirmButton: true,

        }).then(result => {
          if (result.value) {
            this.updating = true
            api.delete(`${getBaseUrl()}api/orctoitem`, {
              params: {
                'iddata': iditem
              }
            }).then((res) => {
              console.log('then axios delete')
              console.log(res.data)
              this.carregarDados()
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Informações excluídas com sucesso!",
                showConfirmButton: false,
                timer: 1500
              })
            })

          }
        })
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de orçamento não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },

    calculaTotalItem() {
      console.log('calculaTotalItem')

      // let desc = this.orctoItemData.desconto
      let quant = this.orctoItemData.qtd
      let vlrUnit = this.orctoItemData.vlrunitliq
      let vlrUnitTab = this.orctoItemData.vlrunitbrt
      let percDesc = 0

      if (quant > 0 && vlrUnit > 0) {

        console.log('valorTotalItem')
        console.log(valorTotalItem)

        if (vlrUnit !== vlrUnitTab) {
          percDesc = (1 - (vlrUnit / vlrUnitTab)) * 100
        }

        let valorTotalItem = quant * vlrUnit

        // this.orctoItemData.desconto = percDesc
        this.orctoItemData.vlrtotalbrt = vlrUnitTab * quant
        this.orctoItemData.vlrtotalliq = valorTotalItem


        if (percDesc > 1000) {
          this.messageValidacaoItem = 'Margem máxima de desconto atingida (30%), favor corrigir antes de confirmar'
        } else {
          this.messageValidacaoItem = ''
        }

        this.orctoItemData.pesobrttot = this.orctoItemData.pesobrtun * quant
        this.orctoItemData.pesoliqtot = this.orctoItemData.pesoliqun * quant
        this.orctoItemData.cubtot = this.orctoItemData.cubunt * quant

      }

    },

    confOrctoItem() {
      console.log('confOrctoItem: ' + this.idData)
      this.v$.$touch()
      this.submitOrctoItem = true

      if (this.v$.$invalid) {
        return;
      } else {
        console.log('formSubmit_validado')
        this.loadingOrctoItem = true

        console.log(`item: ${this.orctoItemData}`)
        api.post(`${getBaseUrl()}api/orctoitem`, {
          orctoItemData: this.orctoItemData
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          this.produtoData = res.data[0]
          this.updating = false

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 2000
          })
          this.loadingOrctoItem = false
          this.showModalOrctoItem = false
          this.carregarDados()
          // this.atualizaPagina()

        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          console.log(err.response)
          console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false
          this.activeTab = 0
          // this.atualizaPagina()
        })

      }
    },



    confOrctoFinanc() {
      console.log('confOrctoFinanc: ' + this.idData)
      this.v$.$touch()
      this.submitOrctoFinanc = true
      if (!this.orctoFinanData.valor && !this.orctoFinanData.formapgto) {
        return;
      } else {
        console.log('submitOrctoFinanc_validado')
        this.orctoFinanData.orcamento_id = this.idData
        this.updating = true
        api.post(`${getBaseUrl()}api/orctofinanc`, {
          orctoFinancData: this.orctoFinanData
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          // this.produtoData = res.data[0]
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
          this.updating = false
          this.showModalOrctoFinan = false
          this.carregarDados()
        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          console.log(err.response)
          console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false
        })
      }
    },



    novoProduto() {
      console.log('novoProduto: ' + this.idData)

      if (this.idData === 0) {

        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Favor salvar o orçamento antes de adicionar item",
          showConfirmButton: false,
          timer: 1500
        })

      } else {
        this.orctoItemData = {}
        this.showModalOrctoItem = true

      }


    },

    detalhesProduto(idProd) {
      console.log('detalhesProduto: ' + idProd)

      this.$router.push(`/produto/detalhe/${idProd}`);

      // let route = this.$router.resolve({ path: "/contact" });
      // window.open(route.href);


    },

    editarProduto(idProd) {
      console.log('editarProduto: ' + idProd)

      if (this.orctoData.status === 'EL') {
        this.showModalOrctoItem = true
        this.loadingOrctoItem = true

        api.get(`${getBaseUrl()}api/orctoitem`, {
          params: { iddata: idProd }
        }).then((res) => {
          console.log('then axios editarProduto')
          console.log(res.data[0])

          this.orctoItemData = res.data[0]

          if (this.orctoItemData.imgs) {
            let imgTrat = this.orctoItemData.imgs.split(',')
            this.orctoItemData.img1 = `${getBaseUrl() + '_IMG'}/peq/${imgTrat[0]}`
          }

          this.loadingOrctoItem = false
        })
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de orçamento não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },

    confirmarOrcamento() {
      console.log('confirmarOrcamento: ' + this.idData)
      console.log(this.orctoData.condpgto)
      console.log(this.condPgtoData)

      console.log(this.orctoData.formapgto)
      console.log(this.formaPgtoData)


      if (this.orctoFinansData.length > 0 && this.orctoData.valorliq !== this.valorTotalFinanc) {

        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Valor financeiro deve ser igual a valor líquido de orçamento, favor corrigir.",
          showConfirmButton: false,
          timer: 2500
        })

      } else {


        if (this.orctoData.tipo === null || this.pedTipoData === null) {

          Swal.fire({
            position: "top-end",
            icon: "warning",
            title: "Favor selecionar tipo de operação antes de confirmar",
            showConfirmButton: false,
            timer: 2500
          })

        } else {

          if (this.orctoData.formapgto === null || this.formaPgtoData === null) {
            Swal.fire({
              position: "top-end",
              icon: "warning",
              title: "Favor selecionar forma de pagamento antes de confirmar",
              showConfirmButton: false,
              timer: 2500
            })
          } else if (this.orctoData.condpgto === null || this.condPgtoData === null) {
            Swal.fire({
              position: "top-end",
              icon: "warning",
              title: "Favor selecionar condição de pagamento antes de confirmar",
              showConfirmButton: false,
              timer: 2500
            })
          } else {
            if (!this.orctoItensData || this.orctoItensData.length <= 0) {
              Swal.fire({
                position: "top-end",
                icon: "warning",
                title: "Favor adicionar produto ao orçamento antes de confirmar",
                showConfirmButton: false,
                timer: 1500
              })
            } else {
              Swal.fire({
                position: "center",
                icon: "question",
                title: "Confirmação de Orçamento",
                text: "Esta operação é irreversível, tem certeza que deseja continuar?",
                confirmButtonText: "Confirmar",
                cancelButtonText: "Cancelar",
                showCancelButton: true,
                showConfirmButton: true,
              }).then(result => {
                if (result.value) {
                  this.updating = true
                  api.post(`${getBaseUrl()}api/focusnfeorctoconf`, { //focusnfeorctoconf | orctoconf
                    iddata: this.idData
                  }).then((res) => {
                    console.log('then axios confirmarOrcamento')
                    console.log(res)
                    let idRedirecionamento = res.data.id;

                    if (res.data.success === true) {
                      if (res.data.processo === 'wmsos') {
                        Swal.fire({
                          position: "top-end",
                          icon: "success",
                          title: "Orçamento confirmado com sucesso",
                          text: "Encaminhando para conferência de saída!",
                          showConfirmButton: false,
                          timer: 4000
                        }).then(() => {
                          console.log('redirecting to wmsos...')
                          this.$router.push(`/wmsos/saidaeditarnova/${idRedirecionamento}`)
                        })
                      } else if (res.data.processo === 'pedido') {
                        Swal.fire({
                          position: "top-end",
                          icon: "success",
                          title: "Orçamento confirmado com sucesso",
                          text: "Encaminhando para o novo pedido que foi criado!",
                          showConfirmButton: false,
                          timer: 4000
                        }).then(() => {
                          console.log('redirecting to pedido...')
                          this.$router.push(`/pedido/detalhe/${idRedirecionamento}`)
                        })
                      }
                    } else {
                      Swal.fire({
                        position: "top-end",
                        icon: "error",
                        title: "Erro ao confirmar o orçamento!",
                        text: res.data[1] ? res.data[1] : 'Erro desconhecido ao confirmar orçamento',
                        showConfirmButton: false,
                        timer: 5000
                      }).then((res) => {
                        console.log(res)
                        this.atualizaPagina()
                      })
                    }
                  })
                }
              })
            }
          }
        }
      }

    },
    cancelarOrcamento() {
      console.log('cancelarOrcamento: ' + this.idData)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Cancelamento de Orçamento",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {

          if (this.idData > 0) {
            this.updating = true
            api.post(`${getBaseUrl()}api/orctocanc`, {
              iddata: this.idData
            }).then((res) => {
              console.log('then axios')
              console.log(res)
              this.orctoData = res.data[0]
              this.updating = false
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Orçamento cancelado com sucesso!",
                showConfirmButton: false,
                timer: 1500
              })
            })
          } else {
            this.$router.go(-1)
          }


        }
      })
    },
    nomeStatus(stsIn) {
      let result = 'Não Definido'
      switch (stsIn) {
        case 'EL':
          result = 'Elabotação'
          break
        case 'FA':
          result = 'Faturado'
          break
        case 'CA':
          result = 'Cancelado'
          break
      }
      return result
    },
    alteraObs() {
      console.log('alteraObs')
      if (this.orctoData.status === 'EL') {
        this.showModalObs = true
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de orçamento não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },
    alteraTransp() {
      console.log('alteraTransp')
      if (this.orctoData.status === 'EL') {
        this.showModalTransp = true
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de orçamento não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },
    alteraFrete() {
      console.log('alteraFrete')
      if (this.orctoData.status === 'EL') {
        this.showModalFrete = true
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de orçamento não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },

    alteraDesconto() {
      console.log('alteraDesconto')
      if (this.orctoData.status === 'EL') {
        this.showModalDesconto = true
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de orçamento não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },


    carregarDados() {
      api.get(`${getBaseUrl()}api/orcamento`, {
        params: { iddata: this.idData }
      }).then((res) => {
        console.log('then axios _orctoEditar')
        console.log(res.data)
        this.orctoData = res.data[0]
        this.clienteData = res.data[1]
        this.pedTipoData = res.data[2]
        this.formaPgtoData = res.data[3]
        this.condPgtoData = res.data[4]
        this.orctoItensData = res.data[5]
        this.represData = res.data[6]
        this.pessoaEnderData = res.data[7]
        this.freteCotaData = res.data[8]
        this.orctoFinansData = res.data[9]
        this.wmsos = res.data[10]
        this.wmsositens = res.data[11]

        let totalFinanc = 0
        this.orctoFinansData.forEach((value) => {
          totalFinanc += value.valor
        })
        this.valorTotalFinanc = totalFinanc



        if (this.freteCotaData && this.freteCotaData.id) {
          this.dtListPesqFreteCota = [
            {
              'codigo': this.freteCotaData.codigo,
              'nome': this.freteCotaData.nome,
            }
          ]
        }


        let valorTotal = 0
        let margemTotal = 0
        if (this.orctoItensData.length > 0) {
          this.orctoItensData.forEach((value) => {
            if (value.imgs) {
              let imgTrat = value.imgs.split(',')
              value.img1 = `${getBaseUrl() + '_IMG'}/peq/${imgTrat[0]}`
            }

            // console.log(value.vlrtotalliq);
            let valor = parseFloat(value.vlrtotalliq)
            valorTotal += valor

            if (value.margem) {
              let valorMargem = parseFloat(value.margem)
              margemTotal += valorMargem
            }

          })
        }

        this.valorTotalItens = valorTotal
        this.margemBrutaOrcto = margemTotal

        this.idData = this.orctoData.id
        this.title = `${this.orctoData.empresa} - Editar Orçamento (${this.orctoData.id}) ${this.clienteData.nome}`
        this.updating = false
      });
    },



    selecionaCli() {
      console.log('selecionaCli')
      if (this.orctoData.status === 'EL') {
        this.showModalCliente = true
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de orçamento não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },


    editaDataOrcamento() {
      console.log('editaDataOrcamento')
      if (this.orctoData.status === 'EL') {
        this.showModalDataOrcamento = true
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de orçamento não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },


    selecionaFormaPgto() {
      console.log('selecionaFormaPgto')
      if (this.orctoData.status === 'EL') {
        this.showModalCondPgto = true
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de orçamento não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },


    selecionaPedTipo() {
      console.log('selecionaPedTipo')
      if (this.orctoData.status === 'EL') {
        console.log(this.orctoData.tipo)
        this.showModalPedTipo = true
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de orçamento não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },


    selecionaRepres() {
      console.log('selecionaRepres')
      if (this.orctoData.status === 'EL') {
        console.log(this.orctoData.repres)
        this.showModalRepres = true
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de orçamento não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },


    selecionaTransp() {
      console.log('selecionaTransp')
      if (this.orctoData.status === 'EL') {
        console.log(this.orctoData.repres)
        this.showModalTransp = true
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de orçamento não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },


    selecionaOrctoItem() {
      console.log('selecionaOrctoItem')
      if (this.orctoData.status === 'EL') {
        this.showModalOrctoItem = true
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de orçamento não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },

    confirmarCliente() {
      console.log('confirmarCliente')
      this.showModalCliente = false

      console.log('this.paramSugereItens')
      console.log(this.paramSugereItens)

      if (this.paramSugereItens === true) {
        console.log('this.paramSugereItens')
        console.log(this.paramSugereItens)
        api.get(`${getBaseUrl()}api/cliultitens`, {
          params: { coddata: this.orctoData.cliente }
        }).then((res) => {
          console.log('then axios_confirmarCliente')
          console.log(res.data)
          this.showModalSugereItens = true
          this.orctoItensSugeridos = res.data[0]
        })
      }

      this.salvarOrcamento()
    },
    confirmarDataOrcamento() {
      console.log('confirmarDataOrcamento')
      this.salvarOrcamento()
      this.showModalDataOrcamento = false
    },
    confirmarFormaPgto() {
      console.log('confirmarFormaPgto')
      this.showModalCondPgto = false
    },
    confirmarPedTipo() {
      console.log('confirmarPedTipo')
      this.showModalPedTipo = false
    },
    confirmarRepres() {
      console.log('confirmarRepres')
      this.salvarOrcamento()
      this.showModalRepres = false
    },
    confirmarTransp() {
      console.log('confirmarTransp')
      this.showModalTransp = false
    },
    confirmarOrctoItem() {
      console.log('confirmarOrctoItem')
      this.showModalOrctoItem = false
    },
    confirmarFrete() {
      console.log('confirmarFrete')
      this.showModalFrete = false
      this.salvarOrcamento()

    },

    confirmarDesconto() {
      console.log('confirmarDesconto')
      this.showModalDesconto = false

      this.updating = true

      this.errosValid = []
      api.post(`${getBaseUrl()}api/orctodesc`, {
        'iddata': this.idData,
        'percdesc': this.orctoData.percdesc
      }).then((res) => {

        console.log('then axios desconto')
        console.log(res)
        this.orctoData = res.data[0]
        this.updating = false

        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações salvas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })

      }).catch((err) => {
        console.log('erro axios')
        // console.log(err)
        // console.log(err.response)
        // console.log(err.response.data.errors)
        let erros = err.response.data.errors
        console.log(erros)
        console.log(typeof erros)
        let listaErros = []
        Object.keys(erros).forEach(key => {
          console.log(key, erros[key]);
          listaErros.push({
            'titulo': key,
            'mensagem': erros[key]
          })
        });
        this.errosValid = listaErros
        this.updating = false
        this.activeTab = 0
      })


    },

    pesqCliente(evt) {
      console.log('pesqCliente')
      console.log(evt)
      let query = evt
      if (query.length > 1) {
        api.get(`${getBaseUrl()}api/clipesq`, {
          params: { q: query, c: 'CL' }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqCli = res.data
        });
      }
    },


    pesqCondPgto(evt) {

      console.log('pesqCondPgto')
      console.log(evt)
      let query = evt

      console.log(query.length)
      if (query.length > 1) {
        this.loadingCondPgto = true
        this.orctoData.condpgto = ''
        api.get(`${getBaseUrl()}api/cpgtopesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtListPesqCondPgto = res.data
        })
      }
    },


    pesqFormaPgto(evt) {
      console.log('pesqFormaPgto')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1) {
        this.loadingFormaPgto = true
        this.orctoData.formapgto = ''
        api.get(`${getBaseUrl()}api/fpgtopesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtListPesqFormaPgto = res.data
        })
      }
    },

    pesqPedTipo(evt) {
      console.log('pesqPedTipo')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1) {
        this.loadingPedTipo = true
        this.orctoData.tipo = ''
        api.get(`${getBaseUrl()}api/tpoprpesq`, {
          params: { q: query, t: 'S', f: this.orctoData.empresa }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtlistPesqPedTipo = res.data
        })
      }
    },

    pesqRepres(evt) {
      console.log('pesqRepres')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1) {
        this.loadingRepres = true
        this.orctoData.repres = ''
        api.get(`${getBaseUrl()}api/reprpesq`, {
          params: { q: query, t: 'S' }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtListPesqRepres = res.data
        })
      }
    },

    pesqTransp(evt) {
      console.log('pesqTransp')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1) {
        this.loadingTransp = true
        this.orctoData.transp = ''
        api.get(`${getBaseUrl()}api/transpesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtListPesqTransp = res.data
        })
      }
    },

    pesqFreteCota(evt) {
      console.log('pesqFreteCota')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1) {
        // this.loadingTransp = true
        this.orctoData.transp = ''
        api.get(`${getBaseUrl()}api/pesqfretecota`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtListPesqFreteCota = res.data
        })
      }
    },

    pesqOrctoItem(evt) {
      console.log('pesqOrctoItem_0')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1) {
        this.dtlistPesqOrctoItem = null
        this.loadingOrctoItem = true
        api.get(`${getBaseUrl()}api/prodpesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          // //console.log(res.data.length)
          this.dtlistPesqOrctoItem = res.data

          this.dtlistPesqOrctoItem.forEach((value) => {
            if (value.imgs) {
              let imgTrat = value.imgs.split(',')
              value.img1 = `${getBaseUrl() + '_IMG'}/peq/${imgTrat[0]}`
            }
            value['descrcodigo'] = value['codigo'] + ' ' + value['descricao'] + ' ' + value['codbarra']
          });

        })
      }
    },

    escolheuCli() {
      console.log('escolheuCli')

      this.loadingCliente = true
      console.log(this.orctoData.cliente)
      api.get(`${getBaseUrl()}api/clicod`, {
        params: { coddata: this.orctoData.cliente }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.clienteData = res.data[0]
        this.ultPedsData = res.data[1]

        let totalPed = 0
        this.ultPedsData.forEach((value) => {
          totalPed += value.valorliq
        });

        this.somaPedidosCli = totalPed
        this.loadingCliente = false
      })
    },

    escolheuCondPgto() {
      console.log('escolheuCondPgto')
      this.loadingCondPgto = true
      console.log(this.orctoData.condpgto)
      api.get(`${getBaseUrl()}api/cpgtocod`, {
        params: { coddata: this.orctoData.condpgto }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.condPgtoData = res.data[0]
        this.ultPedsData = res.data[1]

        let totalPed = 0
        this.ultPedsData.forEach((value) => {
          totalPed += value.valorliq
        });

        this.somaPedidosCli = totalPed
        this.loadingCondPgto = false
      })
    },

    escolheuFormaPgto() {
      console.log('escolheuFormaPgto')
      this.loadingFormaPgto = true
      console.log(this.orctoData.formapgto)
      api.get(`${getBaseUrl()}api/fpgtocod`, {
        params: { coddata: this.orctoData.formapgto }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.formaPgtoData = res.data[0]
        this.ultPedsData = res.data[1]

        let totalPed = 0
        this.ultPedsData.forEach((value) => {
          totalPed += value.valorliq
        });

        this.somaPedidosCli = totalPed
        this.loadingFormaPgto = false
      })
    },

    escolheuPedTipo() {
      console.log('escolheuPedTipo')
      this.loadingPedTipo = true
      console.log(this.orctoData.tipo)
      api.get(`${getBaseUrl()}api/tpoprcod`, {
        params: { coddata: this.orctoData.tipo }
      }).then((res) => {
        console.log('then axios_escolheu_ped_tipo')
        console.log(res.data)
        this.pedTipoData = res.data[0]
        this.ultPedsData = res.data[1]

        let totalPed = 0
        this.ultPedsData.forEach((value) => {
          totalPed += value.valorliq
        });

        this.somaPedidosCli = totalPed
        this.loadingPedTipo = false
      })
    },

    escolheuRepres() {
      console.log('escolheuRepres')
      this.loadingRepres = true
      console.log(this.orctoData.repres)
      api.get(`${getBaseUrl()}api/reprcod`, {
        params: { coddata: this.orctoData.repres }
      }).then((res) => {
        console.log('then axios_escolheu_repres')
        console.log(res.data)
        this.represData = res.data[0]
        this.ultPedsData = res.data[1]

        let totalPed = 0
        this.ultPedsData.forEach((value) => {
          totalPed += value.valorliq
        });

        this.somaPedidosCli = totalPed
        this.loadingRepres = false
      })
    },

    escolheuTransp() {
      console.log('escolheuTransp')
      this.loadingTransp = true
      console.log(this.orctoData.transp)
      api.get(`${getBaseUrl()}api/clicod`, {
        params: { coddata: this.orctoData.transp }
      }).then((res) => {
        console.log('then axios_escolheu_transp')
        console.log(res.data)
        this.transpData = res.data[0]
        this.loadingTransp = false
      })
    },

    escolheuFreteCota() {
      console.log('escolheuFreteCota')
      //this.loadingTransp = true
      console.log(this.orctoData.segto)
      api.get(`${getBaseUrl()}api/fretecotacod`, {
        params: { coddata: this.orctoData.segto }
      }).then((res) => {
        console.log('then axios_escolheu_fretecota')
        console.log(res.data)
        this.freteCotaData = res.data[0]
        //this.loadingTransp = false
      })
    },

    escolheuOrctoItem() {
      console.log('escolheuItem')
      this.loadingOrctoItem = true
      api.get(`${getBaseUrl()}api/prodcod`, {
        params: { coddata: this.orctoItemData.produto }
      }).then((res) => {
        console.log('then axios_escolheu_ped_item')
        console.log(res.data)

        let img1 = ''
        if (res.data[0]['imgs']) {
          img1 = res.data[0]['imgs']
        }

        this.orctoItemData = {
          orcamento_id: this.idData,
          produto_id: res.data[0]['id'],
          produto: res.data[0]['codigo'],
          descprod: res.data[0]['descricao'],
          und: res.data[0]['unidade'],
          vlrunitliq: res.data[0]['preco'],
          vlrunitbrt: res.data[0]['preco'],
          vlrtotalliq: res.data[0]['preco'],
          vlrtotalbrt: res.data[0]['preco'],
          saldo: res.data[0]['saldo'],
          pesobrtun: res.data[0]['pesobrt'],
          pesobrttot: res.data[0]['pesobrt'],
          pesoliqun: res.data[0]['pesoliq'],
          pesoliqtot: res.data[0]['pesoliq'],
          cubunt: cubagemItem(res.data[0], 1).cubunt,
          cubtot: cubagemItem(res.data[0], 1).cubtot,

          img1: img1,
          qtd: 1
        }

        console.log(`orctoItemData: ${this.orctoItemData}`)
        this.ultPedsData = res.data[1]

        let totalPed = 0
        this.ultPedsData.forEach((value) => {
          totalPed += value.valorliq
        });

        this.somaPedidosCli = totalPed
        this.loadingOrctoItem = false
      })
    },

    salvarOrcamento() {
      console.log('salvarOrcamento')
      if (this.orctoData.cliente && this.orctoData.cliente !== '') {
        console.log('salvarOrcamento_00')
        this.updating = true

        this.errosValid = []
        api.post(`${getBaseUrl()}api/orcamento`, {
          orctoData: this.orctoData
        }).then((res) => {
          console.log('then axios')
          console.log(res)

          let success = res.data[0]

          if (!success) {
            Swal.fire({
              position: "top-end",
              icon: "error",
              title: res.data[1],
              showConfirmButton: false,
              timer: 4000
            })
          } else {
            this.orctoData = res.data[0]
            this.updating = false

            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações salvas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })

            if (this.idData === 0) {
              console.log('redirecionar')
              this.$router.replace({ path: `/orcamento/editar/${this.orctoData.id}` })
              this.idData = this.orctoData.id
              this.carregarDados()
            }
          }
        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false
          this.activeTab = 0
        })



      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Favor selecionar cliente antes de salvar o orçamento",
          showConfirmButton: false,
          timer: 1500
        })
      }

    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 2 });
      }
      return "0,00";
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 0 });
      }
      return 0.00;
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatDate(value) {
      // console.log('value formatDate')
      var dateString = value;
      var momentObj = moment(dateString, 'YYYY-MM-DD');
      // console.log(momentObj)
      const formatSaida = "DD/MM/YYYY"
      let dateTime = momentObj.format(formatSaida)
      // console.log(dateTime)
      return dateTime
    },

  }

};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" :status="orctoData.status" />

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>

    <div class="row" v-if="!updating">

      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-start">


              <b-button variant="outline-primary" class="mx-2" @click="salvarOrcamento"
                        :disabled="orctoData.status !== 'EL'" v-if="orctoData.status === 'EL'">
                <i class="bx bx-save font-size-16 align-middle me-2"></i>
                Salvar Alterações
              </b-button>

              <b-button variant="outline-info" class="mx-2" v-if="idData > 0" @click="imprimirOrcamento">
                <i class="bx bx-printer font-size-16 align-middle me-2"></i>
                Imprimir
              </b-button>

              <b-button variant="outline-info" class="mx-2" v-if="idData > 0" @click="copiarOrcamento">
                <i class="bx bx-copy font-size-16 align-middle me-2"></i>
                Copiar
              </b-button>

              <!--              <b-button variant="outline-info" class="mx-2" v-if="idData > 0" @click="copiarOrcamento02">-->
              <!--                <i class="bx bx-copy font-size-16 align-middle me-2" ></i>-->
              <!--                Copiar - 02-->
              <!--              </b-button>-->

              <b-button variant="outline-danger" class="mx-2" @click="cancelarOrcamento"
                        :disabled="orctoData.status !== 'EL'" v-if="orctoData.status === 'EL'">
                <i class="bx bxs-trash font-size-16 align-middle me-2"></i>
                Cancelar Orçamento
              </b-button>

              <b-button variant="outline-warning" class="mx-2" @click="novoProduto"
                        :disabled="orctoData.status !== 'EL'" v-if="orctoData.status === 'EL'">
                <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>
                Novo Produto
              </b-button>

              <b-button variant="outline-primary" class="mx-2" @click="auditoria" :disabled="orctoData.id === 0">
                <i class="bx bx-search-alt font-size-16 align-middle me-2"></i>
                Auditoria
              </b-button>

              <b-button variant="outline-info" class="mx-2" @click="cotarFrete" :disabled="orctoData.id === 0"
                        v-if="orctoData.status === 'EL'">
                <i class="bx bxs-truck font-size-16 align-middle me-2"></i>
                Cotar Frete
              </b-button>

              <b-button variant="outline-success" class="mx-2" @click="novoPagamento" :disabled="orctoData.id === 0"
                        v-if="orctoData.status === 'EL'">
                <i class="bx bxs-dollar-circle font-size-16 align-middle me-2"></i>
                Novo Pagamento
              </b-button>




              <!--                    <span-->
              <!--                        class="avatar-title rounded-circle bg-soft bg-warning text-warning font-size-22"-->
              <!--                    >-->
              <!--                      <i class="mdi mdi-cash"></i>-->
              <!--                    </span>-->
              <div class="flex-grow-1 align-self-center">
                <div class="text-muted">
                  <!--                  <h5>R$ 4.855.745,00 (recebíveis hoje)</h5>-->
                  <!--                  <p class="mb-1">R$ 978.444,00 a pagar hoje</p>-->
                  <!--                  <p class="mb-0">Id no: #SK0234</p>-->
                </div>
              </div>

              <b-button variant="outline-danger" class="mx-2" @click="fecharOrcamento" :disabled="orctoData.id === 0"
                        v-if="orctoData.status === 'EL'">
                <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
                Fechar orçamento
              </b-button>

              <button class="btn btn-success" @click="confirmarOrcamento" :disabled="orctoData.status !== 'EL'"
                      v-if="orctoData.status === 'EL' && orctoItensData && orctoItensData.length > 0">
                <i class="mdi mdi-rocket-launch me-1 text-end"></i> SUCESSO!
              </button>


            </div>
          </div>
        </div>
      </div>

      <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`" show dismissible variant="danger">
        <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
        favor ajustar e tentar novamente.
      </b-alert>

      <div class="col-xl-4">

        <div class="card">
          <div class="card-body">
            <div class="d-flex">
              <div class="me-3">
                <!--                <img-->
                <!--                    src="@/assets/images/users/avatar-2.jpg"-->
                <!--                    alt=""-->
                <!--                    class="avatar-sm rounded-circle img-thumbnail"-->
                <!--                />-->
                <span v-if="clienteData" class="avatar-title rounded-circle" style="max-height: 55px;
                    min-width: 55px;">{{ clienteData.codigo }}
                </span>
              </div>
              <div class="flex-grow-1">
                <div class="d-flex">
                  <div class="flex-grow-1">
                    <h6 class="mb-1 text-muted">Cliente:</h6>
                    <div class="text-muted">
                      <a href="javascript: void(0);" v-if="!clienteData" @click="selecionaCli">
                        <h5 class="mb-1 text-info">Selecionar cliente ...</h5>
                      </a>

                      <a href="javascript: void(0);" v-if="clienteData" v-b-tooltip.hover placement="top"
                         title="Alterar cliente" @click="selecionaCli">
                        <h5 class="mb-1">{{ clienteData.codigo }} - {{ clienteData.nome }}</h5>
                        <p class="mb-0">{{ clienteData.cidade }}, {{ clienteData.estado }}</p>
                      </a>

                    </div>
                  </div>

                  <router-link :to="`/cliente/editar/${clienteData.id}`" class="ms-2" v-if="clienteData"
                               target="_blank">
                    Detalhes Cliente
                    <i class="mdi mdi-arrow-right ms-1"></i>
                  </router-link>
                </div>

                <hr>

                <div>
                  <h6 class="mb-1 text-muted">Representante:</h6>
                  <div class="text-muted">
                    <a href="javascript: void(0);" v-if="!represData" @click="selecionaRepres">
                      <h5 class="mb-1 text-info">Selecionar representante ...</h5>
                    </a>

                    <a href="javascript: void(0);" v-if="represData" v-b-tooltip.hover placement="top"
                       title="Alterar Representante" @click="selecionaRepres">
                      <h5 class="mb-1">{{ represData.codigo }} - {{ represData.descricao }}</h5>
                      <p class="mb-0">{{ represData.cidade }}, {{ represData.estado }}</p>
                    </a>
                  </div>
                </div>

                <hr />
                <div class="row">
                  <h4>Totais</h4>
                  <div class="col-4">
                    <div>
                      <p class="text-muted text-truncate mb-2">Valor total</p>
                      <h6 class="mb-0">R$ {{ orctoData.valorliq ?? formatDecimal(orctoData.valorliq) }}</h6>
                    </div>
                  </div>

                  <div class="col-3">
                    <div>
                      <p class="text-muted text-truncate mb-2">Peso total</p>
                      <h6 class="mb-0">{{ orctoData.pesobrt ?? formatDecimal(orctoData.pesobrt) }} kg</h6>
                    </div>
                  </div>

                  <div class="col-3">
                    <div>
                      <p class="text-muted text-truncate mb-2">Cubagem</p>
                      <h6 class="mb-0">{{ orctoData.cubtot ?? formatDecimal(orctoData.cubtot) }} m³</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>



        <div class="card">
          <div class="card-body">
            <div class="d-flex flex-wrap">

              <a href="javascript: void(0);" v-if="!pedTipoData" @click="selecionaPedTipo">
                <h5 class="card-title mb-3 me-2">{{ orctoData.tipo }}</h5>
              </a>

              <a href="javascript: void(0);" v-if="pedTipoData" v-b-tooltip.hover placement="top"
                 title="Alterar tipo de operação" @click="selecionaPedTipo">
                <h5 class="card-title mb-3 me-2">{{ pedTipoData != null ? pedTipoData.descricao : '' }}</h5>
              </a>

              <b-dropdown toggle-class="text-muted font-size-16 p-0" variant="white" right class="ms-auto"
                          menu-class="dropdown-menu-end">
                <template #button-content>
                  <i class="mdi mdi-dots-horizontal"></i>
                </template>
                <b-dropdown-item href="#" @click="selecionaCli">Alterar Cliente</b-dropdown-item>
                <b-dropdown-item href="#" @click="editaDataOrcamento">Alterar Data do Orçamento</b-dropdown-item>
                <b-dropdown-item href="#" @click="selecionaFormaPgto">Alterar Forma de Pagamento</b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item href="#" @click="selecionaPedTipo">Alterar Tipo de Operação</b-dropdown-item>
                <b-dropdown-item href="#" @click="selecionaRepres">Alterar Representante</b-dropdown-item>
                <b-dropdown-item href="#" @click="selecionaTransp">Alterar Transportadora</b-dropdown-item>
              </b-dropdown>
            </div>

            <div class="d-flex flex-wrap">
              <div>

                <a href="javascript: void(0);" v-if="!formaPgtoData" @click="selecionaFormaPgto">
                  <p class="text-muted mb-1">{{ orctoData.formapgto }}</p>
                </a>
                <a href="javascript: void(0);" v-if="formaPgtoData" v-b-tooltip.hover placement="top"
                   title="Alterar forma de pagamento" @click="selecionaFormaPgto">
                  <p class="text-muted mb-1">{{ formaPgtoData != null ? formaPgtoData.descricao : '' }}</p>
                </a>


                <a href="javascript: void(0);" v-if="condPgtoData" v-b-tooltip.hover placement="top"
                   title="Alterar Data do Orçamento" @click="editaDataOrcamento">
                  <h4 class="mb-3">{{ condPgtoData != null ? condPgtoData.descricao : '' }}</h4>
                </a>


                <a href="javascript: void(0);" v-b-tooltip.hover placement="top" title="Alterar transportadora"
                   @click="alteraTransp">
                  <p class="text-success mb-0">
                    <span>
                      {{ orctoData.transp != null ? orctoData.transp : 'Trans..' }}
                      <i class="mdi mdi-truck-outline ms-1"></i>
                    </span>
                  </p>
                </a>


              </div>
              <div class="ms-auto align-self-end">

                <a href="javascript: void(0);" v-b-tooltip.hover placement="top" title="Alterar representante"
                   @click="selecionaRepres">
                  <i href="javascript: void(0);" class="bx bx-wallet display-4 text-light" @click="selecionaRepres">
                    <h4 class="text-muted mb-3">{{ orctoData.repres != null ? orctoData.repres : '' }}</h4>
                  </i>
                </a>

              </div>
            </div>

            <hr />

            <div class="d-flex flex-wrap">
              <div>
                <a href="javascript: void(0);" v-b-tooltip.hover placement="top" title="Alterar observações"
                   @click="alteraObs">
                  <p class="text-warning mb-0">
                    <span>
                      {{ orctoData.obs != null ? orctoData.obs : 'Observações do Pedido' }}
                      <i class="mdi mdi-chat-alert ms-1"></i>
                    </span>
                  </p>
                </a>
              </div>
            </div>

            <div v-if="orctoData.obsnf" class="d-flex flex-wrap text-end">
              <div>
                <a href="javascript: void(0);" v-b-tooltip.hover placement="top" title="Alterar observações"
                   @click="alteraObs">
                  <p class="text-black mb-0">
                    <span>
                      {{ orctoData.obsnf != null ? orctoData.obsnf : 'Observações da Nota Fiscal' }}
                      <i class="mdi mdi-chat-alert ms-1"></i>
                    </span>
                  </p>
                </a>
              </div>
            </div>

          </div>
        </div>


        <div class="card" v-if="orctoData">
          <div class="card-body">
            <h4 class="card-title mb-3">Detalhamento do orçamento</h4>

            <div class="col-4">
              <div>
                <p class="text-muted text-truncate mb-2">Data do orçamento</p>
                <h6 class="mb-0">{{ formatDate(orctoData.dtemissao) }} </h6>
              </div>
            </div>
            <hr>

            <div class="table-responsive">
              <table class="table mb-0">
                <tbody>

                <tr>
                  <td>Usuário</td>
                  <td class="float-end">{{ orctoData.created_by }}</td>
                </tr>

                <tr>
                  <td>Valor Total Bruto</td>
                  <td class="float-end">R$ {{ formatDecimal(orctoData.valorbrt) }}</td>
                </tr>

                <tr>
                  <td>Valor Desconto Itens</td>
                  <td class="float-end">R$ {{ formatDecimal(orctoData.desconto) }} </td>
                </tr>

                <tr>
                  <td>Valor Total Produtos</td>
                  <td class="float-end">R$ {{ formatDecimal(orctoData.valorprd) }}</td>
                </tr>



                <tr>
                  <td>Desconto Pedido </td>
                  <!--                  <td class="float-end">R$ {{ formatDecimal(orctoData.desconto) }}</td>-->

                  <td class="d-flex float-end">
                    <div class="d-flex justify-content-end">
                      <i class="font-size-16 bx-fade-left"></i>
                    </div>

                    <!-- LINK DE MODAL PARA ALTERAÇÃO DO PERCENTUAL DE DESCONTO DESABILITADO -->
                    <!-- <a href="javascript: void(0);"
                     v-b-tooltip.hover
                     placement="top"
                     title="Alterar porcentagem de desconto"> -->
                    <p class="mb-0">
                        <span>
                          {{ orctoData.percdesc != null ? formatDecimal(orctoData.percdesc) : '0,00' }} %
                        </span>
                    </p>
                    <!-- </a> -->

                  </td>


                </tr>

                <tr>
                  <td>Margem Bruta (média)</td>
                  <td class="float-end">{{ formatDecimal(orctoData.margem) }} %</td>
                </tr>

                <tr>
                  <td>Valor Frete</td>
                  <td class="float-end d-flex">
                    <div class="d-flex justify-content-end">
                      <i class="font-size-16 bx-fade-left"></i>
                    </div>

                    <div v-b-tooltip.hover placement="top">
                      <p class="mb-0">
                          <span>
                            R$ {{ orctoData.valorfrt != null ? formatDecimal(orctoData.valorfrt) : '0,00' }}
                            <!--@click="alteraFrete" - Função desabilitada porque Evandro pediu para deixar o valor da cotação realizada! - Pablo>-->
                          </span>
                      </p>
                    </div>

                  </td>
                </tr>

                <tr>

                  <td>
                      Carga ({{ orctoData.carga }})
                  </td>

                  <td class="float-end d-flex">
                    <div class="d-flex justify-content-end">
                      <i class="font-size-16 bx-fade-left"></i>
                    </div>

                    <div v-b-tooltip.hover placement="top">
                      <p class="mb-0">
                          <span>
                            <h6 class="mb-0">{{ orctoData.cubcarga ?? formatDecimal(orctoData.cubcarga) }} m³</h6>
                          </span>
                      </p>
                    </div>

                  </td>
                </tr>


                <tr>
                  <th>Valor Total Líquido</th>
                  <th class="float-end">R$ {{ formatDecimal(orctoData.valorliq) }}</th>
                </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>


        <div class="card" v-if="orctoData">
          <div class="card-body">
            <h4 class="card-title mb-3">Pagamentos</h4>

            <div class="table-responsive">
              <table class="table mb-0">
                <tbody>


                <tr v-for="data in orctoFinansData" :key="data.id">

                  <td>
                    <a href="javascript: void(0);" v-b-tooltip.hover placement="top" title="Editar pagamento"
                       @click="alteraPagamento(data)">
                      {{ data.formapgtodesc }} | {{ data.obs }}
                    </a>
                  </td>

                  <td class="float-end">
                    <a href="javascript: void(0);" v-b-tooltip.hover placement="top" title="Editar pagamento"
                       @click="alteraPagamento(data)">
                      {{ formatDecimal(data.valor) }}
                    </a>
                  </td>


                </tr>

                <tr>
                  <td>Valor Total Pagamentos</td>
                  <td class="float-end">R$ {{ formatDecimal(valorTotalFinanc) }}</td>
                </tr>



                </tbody>
              </table>
            </div>
            <!-- end table-responsive -->
          </div>
        </div>




      </div>

      <!--      Grid de itens-->


      <div class="col-xl-8">
        <b-tabs pills justified content-class="p-3 text-muted">
          <b-tab active class="border-0">
            <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-home"></i>
                  </span>
              <span class="d-none d-sm-inline-block">Itens Orçamento</span>
            </template>

            <div class="card">
              <div class="card-body">
                <div class="table-responsive">
                  <table class="table align-middle mb-0 table-nowrap">
                    <thead class="table-light">
                    <tr>
                      <th>Produtos ({{ orctoItensData !== null ? orctoItensData.length : 0 }})</th>
                      <th>Descrição</th>
                      <th class="text-center">Valor Unit.(R$)</th>
                      <th class="text-center">Peso total</th>
                      <th class="text-center">Cubagem total</th>
                      <th class="text-center">Quantidade</th>
                      <th class="text-center">A conferir</th> <!-- saldo restante de wmsos -->
                      <th class="text-center">Margem(%)</th>
                      <th class="text-center">Desconto unitário(R$)</th>
                      <th class="text-center">Total Líquido(R$)</th>
                      <th class="text-center">Ações</th>
                    </tr>
                    </thead>
                    <tbody>

                    <tr v-for="data in orctoItensData" :key="data.id">

                      <td>
                        <h5 class="text-muted mb-0">{{ data.produto }} </h5>

                        <img v-if="data.img1" :src="data.img1" alt="product-img" title="product-img" class="avatar-md" />

                        <div class="mb-3" v-else>
                          <i class="bx bxs-camera-off h2 text-warning" title="Produto sem foto"></i>
                        </div>

                      </td>

                      <td>
                        <h5 class="font-size-14 text-truncate">
                          <a href="javascript: void(0);" class="text-body fw-bold text-wrap"
                             @click="editarProduto(data.id)">
                            {{ data.descprod }}
                          </a>
                        </h5>
                        <p class="mb-0">
                          <!--                      Saldo:-->
                          <!--                      <span class="fw-medium"> {{ formatInteger(data.id)  }} </span>-->
                        </p>
                      </td>

                      <td class="text-end">{{ formatDecimal(data.vlrunitbrt) }}</td>
                      <td class="text-center">{{ formatDecimal(data.pesobrttot) }}Kg</td>
                      <td class="text-center">{{ data.cubtot }}m³</td>
                      <td class="text-center">{{ formatDecimal(data.qtd) }}</td>
                      <td class="center">
                        <i class="bx bx-package"></i>
                        <span :class="data.aconferirqtd > 1 ? 'badge-soft-warning' :
                                      data.aconferirqtd == 0 ? 'badge-soft-success' :
                                      'badge-soft-danger'
                          ">
                          {{ formatDecimal(data.aconferirqtd) }}
                        </span>
                      </td>
                      <td class="text-center">{{ formatDecimal(data.margem) }}</td>

                      <td class="text-end">
                      <span class="badge badge-pill badge-soft-success font-size-11" v-if="data.desconto !== 0.00"
                            :class="data.desconto < 0.00 ? 'badge-soft-success' :
                          data.desconto > 0 ? 'badge-soft-danger' : ''">
                        {{ formatDecimal(data.desconto) }}
                      </span>
                        <span v-else>
                        0.00
                      </span>
                      </td>

                      <td class="text-end">{{ formatDecimal(data.vlrtotalliq) }}</td>

                      <td class="text-end">

                        <a href="javascript:void(0);" class="action-icon text-success mx-2"
                           @click="detalhesProduto(data.produto_id)">
                          <i class="mdi mdi-eye font-size-18"></i>
                        </a>

                        <a href="javascript:void(0);" v-if="orctoData.status === 'EL'"
                           class="action-icon text-warning mx-2" @click="editarProduto(data.id)">
                          <i class="mdi mdi-pencil-outline font-size-18"></i>
                        </a>

                        <a href="javascript:void(0);" v-if="orctoData.status === 'EL'"
                           class="action-icon text-danger mx-2" @click="deletarOrctoItem(data.id)">
                          <i class="mdi mdi-trash-can font-size-18"></i>
                        </a>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </b-tab>


          <b-tab>
            <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="far fa-user"></i>
                  </span>
              <span class="d-none d-sm-inline-block">Saldos de conferência</span>
            </template>

            <template v-if="wmsositens.length > 0">
              <div class="card">
                <table class="table align-middle mb-0 table-nowrap">
                  <thead class="table-light">
                  <tr>
                    <th>WmsOs Id</th>
                    <th>Produto ({{ wmsositens.length > 0 ? wmsositens.length : 0 }})</th>
                    <th class="text-center">Nome</th>
                    <th class="text-center">Unidade</th>
                    <th class="text-center">Total itens</th>
                    <th class="text-center">Conferidos</th>
                    <th class="text-center">Pendentes</th>
                    <th class="text-center">user</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="wmsositem in wmsositens" :key="wmsositem.produto_id">
                    <td class="text-start">{{ wmsositem.wmsos_id }}</td>
                    <td class="text-start">{{ wmsositem.produto }}</td>
                    <td class="text-end">{{ wmsositem.descprod }}</td>
                    <td class="text-end">{{ wmsositem.und }}</td>
                    <td class="text-end">{{ wmsositem.qtd }}</td>
                    <td class="text-end">{{ wmsositem.qtdlida }}</td>
                    <td class="text-end">{{ wmsositem.qtddisp }}</td>
                    <td class="text-end">{{ wmsositem.updated_by ?? '-' }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </template>
            <template v-else>
              <b-alert variant="warning" show>
                <h4 class="alert-heading">Tudo certo por aqui!</h4>
                <p>
                  Nenhuma conferência atrelada à esse orçamento foi realizada!
                </p>
              </b-alert>
            </template>
          </b-tab>

          <b-tab>
            <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="far fa-user"></i>
                  </span>
              <span class="d-none d-sm-inline-block">OS relacionadas</span>
            </template>

            <template v-if="wmsos.length > 0">
              <div class="card">
                <table class="table align-middle mb-0 table-nowrap">
                  <thead class="table-light">
                  <tr>
                    <th>WmsOs ({{ wmsos.length > 0 ? wmsos.length : 0 }})</th>
                    <th class="text-center">Status</th>
                    <th class="text-center">Data criação</th>
                    <th class="text-center">Iniciado por</th>
                    <th class="text-center">Última atualização</th>
                    <th class="text-center">Atualizador por</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="os in wmsos" :key="os.id">
                    <h5 class="font-size-14 text-truncate">
                      <a href="javascript: void(0);" class="text-body fw-bold text-wrap"
                         @click="redirecionaPedido(os.id)">
                        {{ os.id }}
                      </a>
                    </h5>
                    <td class="text-start">{{ os.status }}</td>
                    <td class="text-end">{{ os.created_at_formatted }}</td>
                    <td class="text-end">{{ os.created_by }}</td>
                    <td class="text-end">{{ os.updated_at_formatted }}</td>
                    <td class="text-end">{{ os.updated_by ?? '-' }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </template>
            <template v-else>
              <b-alert variant="warning" show>
                <h4 class="alert-heading">Tudo certo por aqui!</h4>
                <p>
                  Não existe nenhum pedido atrelado à esse orçamento!
                </p>
              </b-alert>
            </template>
          </b-tab>
        </b-tabs>
      </div>
    </div>

    <b-modal size="lg" :title="clienteData != null ? `Detalhes Cliente (${clienteData.nome})` : 'Detalhes Cliente'"
             v-model="showModalCliente" centered hide-footer>

      <div class="col-md-12">
        <div class="mb-3">
          <span>Selecionar Novo Cliente</span>

          <multiselect id="inputCliente" @search-change="pesqCliente" @select="escolheuCli" v-model="orctoData.cliente"
                       placeholder="Pesquisar cliente" :options="dtListPesqCli" :searchable="true" label="nome" track-by="nome"
                       value-prop="codigo">
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4">
                    {{ slotProps.option.cnpj }}
                  </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.nome }}</div>
                <div class="align-items-end text-end align-content-end">{{ slotProps.option.cidade }} - {{
                    slotProps.option.estado }}</div>
              </div>
            </template>
          </multiselect>

        </div>
      </div>


      <div class="row" v-if="loadingCliente">
        <div class="col-12 text-center">
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
        </div>
      </div>

      <div v-if="!loadingCliente && clienteData">
        <router-link :to="`/cliente/detalhe/${clienteData.id}`" target="_blank">
          <p class="mb-2">
            Código:
            <span class="text-primary"> {{ clienteData.codigo }} </span>
          </p>
        </router-link>
        <p class="mb-2" v-if="orctoData.cliender === 1">
          <span class="text-muted"> Entregar: </span>
          <span> {{ clienteData.rua }}, {{ clienteData.numero }}, {{ clienteData.bairro }} </span>
          <span> | </span>
          <span> {{ clienteData.cidade }} - {{ clienteData.estado }} </span>
        </p>

        <p class="mb-2" v-if="orctoData.cliender === 2">
          <span class="text-muted"> Entregar: </span>
          <span> {{ pessoaEnderData.rua1 }}, {{ pessoaEnderData.numero1 }}, {{ pessoaEnderData.bairro1 }} </span>
          <span> | </span>
          <span> {{ pessoaEnderData.cidade1 }} - {{ pessoaEnderData.estado1 }} </span>
        </p>

        <p class="mb-2" v-if="orctoData.cliender === 3">
          <span class="text-muted"> Entregar: </span>
          <span> {{ pessoaEnderData.rua2 }}, {{ pessoaEnderData.numero2 }}, {{ pessoaEnderData.bairro2 }} </span>
          <span> | </span>
          <span> {{ pessoaEnderData.cidade2 }} - {{ pessoaEnderData.estado2 }} </span>
        </p>

        <p class="mb-4">



        </p>

        <p class="mb-4">
          <span> {{ clienteData.tel1 }} / {{ clienteData.email }}</span>
        </p>
        <div class="table-responsive">
          <table class="table table-centered table-nowrap">
            <thead>
            <tr>
              <th scope="col">Últimos Pedidos</th>
              <th scope="col" class="text-end">Data</th>
              <th scope="col" class="text-end">Valor (R$)</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="data in ultPedsData" :key="data.id">
              <td>
                <router-link :to="`/orcamento/editar/${data.id}`" target="_blank">
                  <div>
                    <h5 class="text-truncate font-size-14">
                      {{ data.codigo }}
                    </h5>
                  </div>
                </router-link>
              </td>
              <td class="text-end">{{ formatDateTime(data.created_at) }}</td>
              <td class="text-end">{{ formatDecimal(data.valorliq) }}</td>
            </tr>
            <tr>
              <td colspan="2">
                <h6 class="m-0 text-end">Valor Total Pedidos:</h6>
              </td>
              <td class="text-end">R$ {{ formatDecimal(somaPedidosCli) }}</td>
            </tr>
            <tr>
              <td colspan="2">
                <h6 class="m-0 font-size-14  text-end">Ticket Médio:</h6>
              </td>
              <td class="font-size-14 text-end">R$ {{ formatDecimal(somaPedidosCli / 3) }}</td>
            </tr>
            </tbody>
          </table>
        </div>

      </div>


      <div v-if="clienteData && showSelecionarEnder">
        <div class="mb-2">
          <label>Selecionar Endereço de Entrega:</label>

          <div class="row">

            <div class="col-xl-4 col-sm-4">
              <div class="mb-3">
                <label class="card-radio-label mb-2">
                  <input type="radio" v-model="orctoData.cliender" :value="1" name="currency" id="buycurrencyoption1"
                         class="card-radio-input" checked />
                  <div class="card-radio">
                    <div>
                      <i class="mdi mdi-office-building-marker-outline font-size-24 text-warning align-middle me-2"></i>
                      <span>{{ clienteData.cidade }} - {{ clienteData.estado }}</span>
                    </div>
                  </div>
                </label>

                <div>
                  <p class="text-muted mb-1 text-wrap">{{ clienteData.rua }}, {{ clienteData.numero }}</p>
                  <h5 class="font-size-16">{{ clienteData.bairro }} - {{ clienteData.cep }}</h5>
                </div>
              </div>
            </div>

            <div class="col-xl-4 col-sm-4" v-if="pessoaEnderData">
              <div class="mb-3">
                <label class="card-radio-label mb-2">
                  <input type="radio" v-model="orctoData.cliender" :value="2" name="currency" id="buycurrencyoption2"
                         class="card-radio-input" />
                  <div class="card-radio">
                    <div>
                      <i class="mdi mdi-office-building-marker-outline font-size-24 text-primary align-middle me-2"></i>
                      <span>{{ pessoaEnderData.cidade1 }} - {{ pessoaEnderData.estado1 }}</span>
                    </div>
                  </div>
                </label>
                <div>
                  <p class="text-muted mb-1">{{ pessoaEnderData.rua1 }}, {{ pessoaEnderData.numero1 }}</p>
                  <h5 class="font-size-16">{{ pessoaEnderData.bairro1 }} - {{ pessoaEnderData.cep1 }}</h5>
                </div>
              </div>
            </div>

            <div class="col-xl-4 col-sm-4" v-if="pessoaEnderData && pessoaEnderData.cidade2">
              <div class="mb-3">
                <label class="card-radio-label mb-2">
                  <input type="radio" v-model="orctoData.cliender" :value="3" name="currency" id="buycurrencyoption3"
                         class="card-radio-input" />

                  <div class="card-radio">
                    <div>
                      <i class="mdi mdi-home font-size-24 text-info align-middle me-2"></i>
                      <span>{{ pessoaEnderData.cidade2 }} - {{ pessoaEnderData.estado2 }}</span>
                    </div>
                  </div>
                </label>

                <div>
                  <p class="text-muted mb-1">{{ pessoaEnderData.rua2 }}, {{ pessoaEnderData.numero2 }}</p>
                  <h5 class="font-size-16">{{ pessoaEnderData.bairro2 }} - {{ pessoaEnderData.cep2 }}</h5>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div>
        <div class="text-start mt-5">
          <a href="javascript: void(0);" @click="showSelecionarEnder = !showSelecionarEnder">
            <i class="bx bx-pencil font-size-16 align-middle me-2"></i>
            Alterar Endereço de Entrega
          </a>
        </div>
      </div>

      <div>
        <div class="text-start mt-3">
          <router-link to="/cliente/editar/0" target="_blank">
            <i class="bx bx-plus font-size-16 align-middle me-2"></i>
            Cadastrar Novo Cliente
          </router-link>

        </div>
      </div>


      <div v-if="!loadingCliente && clienteData">
        <div class="text-end mt-0">
          <b-button variant="light" @click="showModalCliente = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>

          <b-button type="submit" variant="success" class="ms-1" @click="confirmarCliente">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>

    <b-modal title="Detalhes Tipo de operação" v-model="showModalPedTipo" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <span>Selecionar Novo Tipo de Operação</span>

          <multiselect id="tipooperacao" @search-change="pesqPedTipo" @select="escolheuPedTipo" v-model="orctoData.tipo"
                       placeholder="Pesquisar tipo de operação" :options="dtlistPesqPedTipo" :searchable="true" label="descricao"
                       track-by="descricao" value-prop="codigo">
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4">

                  </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>
                <span class="mx-4">
                </span>
                <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at)
                  }} </div>
              </div>
            </template>
          </multiselect>

        </div>
      </div>

      <div class="row" v-if="loadingPedTipo">
        <div class="col-12 text-center">
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
        </div>
      </div>


      <div v-if="!loadingPedTipo && pedTipoData">
        <p class="mb-2">
          Tipo de Operação Atual
        </p>
        <router-link :to="`/tiposopera/list`" target="_blank">
          <p class="mb-2">
            Código:
            <span class="text-primary"> {{ pedTipoData.codigo }} </span>
          </p>

          <p class="mb-2">
            Descrição:
            <span class="text-primary"> {{ pedTipoData.descricao }} </span>
          </p>
        </router-link>

        <div class="table-responsive" v-if="ultPedsData">
          <table class="table table-centered table-nowrap">
            <thead>
            <tr>
              <th scope="col">Últimos Pedidos</th>
              <th scope="col" class="text-end">Data</th>
              <th scope="col" class="text-end">Valor (R$)</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="data in ultPedsData" :key="data.id">
              <td>
                <router-link :to="`/orcamento/editar/${data.id}`" target="_blank">
                  <div>
                    <h5 class="text-truncate font-size-14">
                      {{ data.codigo }}
                    </h5>
                  </div>
                </router-link>
              </td>
              <td class="text-end">{{ formatDateTime(data.created_at) }}</td>
              <td class="text-end">{{ formatDecimal(data.valorliq) }}</td>
            </tr>
            <tr>
              <td colspan="2">
                <h6 class="m-0 text-end">Valor Total Pedidos:</h6>
              </td>
              <td class="text-end">R$ {{ formatDecimal(somaPedidosCli) }}</td>
            </tr>
            <tr>
              <td colspan="2">
                <h6 class="m-0 font-size-14  text-end">Ticket Médio:</h6>
              </td>
              <td class="font-size-14 text-end">R$ {{ formatDecimal(somaPedidosCli / 3) }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalPedTipo = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confirmarPedTipo">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>

    <b-modal size="lg" title="Alterar Observações" v-model="showModalObs" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="obs">Observações do Pedido</label>
          <textarea id="obs" v-model="orctoData.obs" type="text" rows="3" class="form-control"
                    placeholder="Observações do Pedido" />
        </div>

        <div class="mb-3">
          <label for="obsnf">Observações da Nota Fiscal</label>
          <textarea id="obsnf" v-model="orctoData.obsnf" type="text" rows="3" class="form-control"
                    placeholder="Observações da Nota Fiscal" />
        </div>


        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalObs = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="showModalObs = false">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>

    <b-modal title="Alterar Valor de Frete" v-model="showModalFrete" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="valorfrt">Favor informar o valor do frete</label>
          <input id="valorfrt" v-model="orctoData.valorfrt" type="number" class="form-control"
                 placeholder="Valor do frete (R$)" />
        </div>

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalFrete = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confirmarFrete">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>

    <b-modal title="Alterar Porcentagem de Desconto" v-model="showModalDesconto" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="percdesc">Favor informar a nova porcentagem de desconto (%)</label>
          <input id="percdesc" v-model="orctoData.percdesc" type="number" class="form-control"
                 placeholder="Porcentagem de Desconto (%)" />
        </div>

        <!--        <b-alert show dismissible variant="danger" >-->
        <!--          <i class="mdi mdi-alert me-2"></i>Todos os produtos serão recalculados-->
        <!--        </b-alert>-->


        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalDesconto = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>


          <b-button type="submit" variant="success" class="ms-1" @click="confirmarDesconto">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>

    <b-modal title="Auditoria" v-model="showModalAuditoria" centered hide-footer>

      <div class="row">
        <div class="col-md-6">
          <div class="mb-3">
            <label for="created_by">Usuário Criação</label>
            <input id="created_by" v-model="orctoData.created_by" type="text" class="form-control" :disabled="true"
                   placeholder="Usuário Criação" />
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label for="created_at">Criado em</label>
            <input id="created_at" v-model="orctoData.created_at" type="datetime-local" class="form-control"
                   :disabled="true" placeholder="Criado em" />
          </div>
        </div>
      </div>


      <div class="row">
        <div class="col-md-6">
          <div class="mb-3">
            <label for="updated_by">Usuário Atualização</label>
            <input id="updated_by" v-model="orctoData.updated_by" type="text" class="form-control" :disabled="true"
                   placeholder="Usuário Atualização" />
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label for="updated_at">Atualizado em</label>
            <input id="updated_at" v-model="orctoData.updated_at" type="datetime-local" class="form-control"
                   :disabled="true" placeholder="Atualizado em" />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">


          <div class="text-end mt-5">
            <b-button variant="light" @click="showModalAuditoria = false">
              <i class="bx bx-block font-size-16 align-middle me-2"></i>
              Fechar
            </b-button>

          </div>
        </div>
      </div>

    </b-modal>

    <b-modal title="Detalhes Representante" v-model="showModalRepres" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <span>Selecionar Novo Representante</span>

          <multiselect id="repres" @search-change="pesqRepres" @select="escolheuRepres" v-model="orctoData.repres"
                       placeholder="Pesquisar representante" :options="dtListPesqRepres" :searchable="true" label="descricao"
                       track-by="descricao" value-prop="codigo">
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4">

                  </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>
                <span class="mx-4">
                </span>
                <span class="mx-4">
                </span>
                <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at)
                  }} </div>

              </div>
            </template>
          </multiselect>

        </div>
      </div>

      <div class="row" v-if="loadingRepres">
        <div class="col-12 text-center">
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
        </div>
      </div>


      <div v-if="!loadingRepres && represData">
        <p class="mb-2">
          Representante Atual
        </p>
        <router-link :to="`/tiposopera/list`" target="_blank">
          <p class="mb-2">
            Código:
            <span class="text-primary"> {{ represData.codigo }} </span>
          </p>

          <p class="mb-2">
            Nome:
            <span class="text-primary"> {{ represData.descricao }} </span>
          </p>
        </router-link>

        <div class="table-responsive" v-if="ultPedsData">
          <table class="table table-centered table-nowrap">
            <thead>
            <tr>
              <th scope="col">Últimos Pedidos</th>
              <th scope="col" class="text-end">Data</th>
              <th scope="col" class="text-end">Valor (R$)</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="data in ultPedsData" :key="data.id">
              <td>
                <router-link :to="`/orcamento/editar/${data.id}`" target="_blank">
                  <div>
                    <h5 class="text-truncate font-size-14">
                      {{ data.codigo }}
                    </h5>
                  </div>
                </router-link>
              </td>
              <td class="text-end">{{ formatDateTime(data.created_at) }}</td>
              <td class="text-end">{{ formatDecimal(data.valorliq) }}</td>
            </tr>
            <tr>
              <td colspan="2">
                <h6 class="m-0 text-end">Valor Total Pedidos:</h6>
              </td>
              <td class="text-end">R$ {{ formatDecimal(somaPedidosCli) }}</td>
            </tr>
            <tr>
              <td colspan="2">
                <h6 class="m-0 font-size-14  text-end">Ticket Médio:</h6>
              </td>
              <td class="font-size-14 text-end">R$ {{ formatDecimal(somaPedidosCli / 3) }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalRepres = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confirmarRepres">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>

    <b-modal title="Detalhes Transportadora" v-model="showModalTransp" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <span>Selecionar Nova Transportadora</span>

          <multiselect id="repres" @search-change="pesqTransp" @select="escolheuTransp" v-model="orctoData.transp"
                       placeholder="Pesquisar transportadora" :options="dtListPesqTransp" :searchable="true" label="nome"
                       track-by="nome" value-prop="codigo">
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4">

                  </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.nome }}</div>
                <span class="mx-4">
                </span>
                <span class="mx-4">
                </span>
                <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at)
                  }} </div>

              </div>
            </template>
          </multiselect>

        </div>
      </div>

      <div class="row" v-if="loadingTransp">
        <div class="col-12 text-center">
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
        </div>
      </div>


      <div class="col-md-12">
        <div class="mb-3">
          <span>Seguimento Frete</span>

          <multiselect id="repres" @search-change="pesqFreteCota" @select="escolheuFreteCota" v-model="orctoData.segto"
                       placeholder="Pesquisar seguimento" :options="dtListPesqFreteCota" :searchable="true" label="nome"
                       track-by="nome" value-prop="codigo">
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4">

                  </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.nome }}</div>
                <span class="mx-4">
                </span>
                <span class="mx-4">
                </span>
                <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at)
                  }} </div>

              </div>
            </template>
          </multiselect>

        </div>
      </div>


      <!--      <div class="col-sm-12">-->
      <!--        <div class="mb-3">-->
      <!--          <label for="segto">Seguimento</label>-->
      <!--          <select-->
      <!--              id="segto"-->
      <!--              v-model="orctoData.segto"-->
      <!--              class="form-control">-->
      <!--            <option value="58">0 APRESENTAÇÃO</option>-->
      <!--            <option value="51">4 BIS</option>-->
      <!--            <option value="13">ABRASIVOS</option>-->
      <!--            <option value="101">ACIMAQ - ACESSÓRIOS</option>-->
      <!--            <option value="102">ACIMAQ - LINHA BRANCA</option>-->
      <!--            <option value="141">ACIMAQ - VTEX</option>-->
      <!--            <option value="31">ADESIVOS</option>-->
      <!--            <option value="62">AEREO</option>-->
      <!--            <option value="67">AEROFLEX(ONCOVIT)</option>-->
      <!--            <option value="203">Air Fresh</option>-->
      <!--            <option value="121">ALIMENTO FRACIONADO</option>-->
      <!--            <option value="89">APRESENTAÇÃO SP</option>-->
      <!--            <option value="224">ARELL</option>-->
      <!--            <option value="167">ARTMENTO - REPRESENTAÇÃO</option>-->
      <!--            <option value="158">ARTMENTO - REVENDA</option>-->
      <!--            <option value="181">ARTMENTO TROCA DE NF</option>-->
      <!--            <option value="164">ARTWAX</option>-->
      <!--            <option value="257">ASCLÉ PHARMA</option>-->
      <!--            <option value="267">ASCLÉ PHARMA - PERECÍVEL</option>-->
      <!--            <option value="34">ATIVA</option>-->
      <!--            <option value="170">AUDITORIA JAMEF</option>-->
      <!--            <option value="17">AUTOPEÇAS</option>-->
      <!--            <option value="82">BIANCO-VINILICO</option>-->
      <!--            <option value="53">BIANCOGRES</option>-->
      <!--            <option value="14">BICICLETAS</option>-->
      <!--            <option value="160">BID ONCOVIT - AÉREO</option>-->
      <!--            <option value="162">BID ONCOVIT - RODO NÃO PERECÍVEL</option>-->
      <!--            <option value="161">BID ONCOVIT - RODO PERECÍVEL</option>-->
      <!--            <option value="227">BLUEVIX</option>-->
      <!--            <option value="157">BOA PRACA IMPORTADORA</option>-->
      <!--            <option value="30">BOBINAS/PAPEL</option>-->
      <!--            <option value="198">Brametal Fracionado</option>-->
      <!--            <option value="63">BRASPRESS (GOLDEN)</option>-->
      <!--            <option value="46">CAIXOTIN</option>-->
      <!--            <option value="94">CAPEÇAS</option>-->
      <!--            <option value="122">CARRETA | ALIMENTO</option>-->
      <!--            <option value="134">CARROSEL FORNECEDORES[MENSAL] MG</option>-->
      <!--            <option value="135">CARROSEL FORNECEDORES[MENSAL] SP</option>-->
      <!--            <option value="133">CARROSEL FORNECEDORES[VIAGEM] MG</option>-->
      <!--            <option value="136">CARROSEL FORNECEDORES[VIAGEM] SP</option>-->
      <!--            <option value="253">Casa Eurico</option>-->
      <!--            <option value="191">CAÚS - ELETRODOMÉSTICOS</option>-->
      <!--            <option value="192">CAÚS - LINHA BRANCA</option>-->
      <!--            <option value="187">CAÚS - MÓVEIS</option>-->
      <!--            <option value="277">CAÚS BAIXO GUANDÚ</option>-->
      <!--            <option value="92">CELDOM - ACESSÓRIOS</option>-->
      <!--            <option value="91">CELDOM - LINHA BRANCA</option>-->
      <!--            <option value="254">CELEIRO BIKE</option>-->
      <!--            <option value="266">CELER</option>-->
      <!--            <option value="149">CHARME DO DETALHE</option>-->
      <!--            <option value="44">CICLOVIX</option>-->
      <!--            <option value="249">CIRCUIT</option>-->
      <!--            <option value="71">CLICK MUSIC</option>-->
      <!--            <option value="155">CNLOG</option>-->
      <!--            <option value="189">COBATA</option>-->
      <!--            <option value="142">COLIBRI COMPRAS FOB</option>-->
      <!--            <option value="138">COLIBRI E-COMMERCE</option>-->
      <!--            <option value="41">Conciliacao</option>-->
      <!--            <option value="200">Conciliação de tabela</option>-->
      <!--            <option value="32">COPY SUPPLY</option>-->
      <!--&lt;!&ndash;            <option value=""></option>&ndash;&gt;-->
      <!--&lt;!&ndash;            <option value=""></option>&ndash;&gt;-->
      <!--&lt;!&ndash;            <option value=""></option>&ndash;&gt;-->

      <!--            &lt;!&ndash;-->
      <!--200-->
      <!--32-->
      <!--5	COSMÉTICOS-->
      <!--28	COSMÉTICOS 2-->
      <!--69	COSTA-ACESSÓRIOS-->
      <!--66	COSTA-LOTAÇÃO-->
      <!--68	COSTA-PERFIL-->
      <!--195	CREATIVE COPIAS-->
      <!--196	CREATIVE EXPRESSO-->
      <!--260	D' FLORENCE-->
      <!--176	dallabernardina-->
      <!--128	DISTRIBUIÇÃO DE PERFIS-->
      <!--219	DRIVE PNEUS-->
      <!--247	DUCOPRINT-->
      <!--145	E-COMMERCE CARIACICA-->
      <!--263	EQUIPA FÁCIL-->
      <!--15	ETIQUETAS E ROTULOS-->
      <!--165	FECVA-->
      <!--19	FERRAMENTAS-->
      <!--210	FIOLUX-->
      <!--273	FRETE DESTACADO - 125 - GOLDEN LINHA BRANCA-->
      <!--274	FRETE DESTACADO - 215 - Golden - Não Compete-->
      <!--272	FRETE DESTACADO - 30 - BOBINAS/PAPEL-->
      <!--271	FRETE DESTACADO - 9 - GOLDEN-->
      <!--120	FRETE DESTACADO - GOLDEN AÉREO-->
      <!--55	FRETE LOT.GERAL-->
      <!--1	FRETE SPOT-->
      <!--143	FUSION-->
      <!--117	GAZIN ATACADO - ACESSÓRIOS-->
      <!--118	GAZIN ATACADO - LINHA BRANCA-->
      <!--93	GAZIN ECOMMERCE - ACESSÓRIOS-->
      <!--98	GAZIN ECOMMERCE - LINHA BRANCA-->
      <!--154	GAZIN ECOMMERCE NOVO 2021-->
      <!--238	GERAR VTEX-->
      <!--226	GLOBO PHARMA-->
      <!--9	GOLDEN-->
      <!--99	GOLDEN - B2C-->
      <!--258	Golden - Carga Dedicada-->
      <!--125	GOLDEN - LINHA BRANCA-->
      <!--215	Golden - Não Compete-->
      <!--265	GOLDEN RELATÓRIOS-->
      <!--54	GOLDEN TOTEM-->
      <!--150	GOLDEN-ELETRÔNICOS-APENAS ANALISE-->
      <!--47	GRANCAFE-->
      <!--156	GRANSOLDAS-->
      <!--262	GRUPO BARÃO-->
      <!--244	GRUPO FESTAS-->
      <!--151	GRUPO FORT FLEX-->
      <!--243	GRUPO JPP-->
      <!--77	HAYOM - PERF INFORMATICA-->
      <!--84	HOSPIDROGAS AEREO-->
      <!--85	HOSPIDROGAS INSUMOS E EQUIPAMENTOS-->
      <!--100	HOSPIDROGAS MEDICAMENTOS-->
      <!--152	HOSPITAL HOME-->
      <!--185	IMAGINIA-->
      <!--214	INSTITUTO AGUA VIVA-->
      <!--8	INSUMOS MOVELARIA-->
      <!--7	INSUMOS SIDERURGIA-->
      <!--132	INTERCOMPANY SP-->
      <!--131	INTERCOMPANY[MENSAL] VV-->
      <!--139	INTERCOMPANY[VIAGEM] VV-->
      <!--148	JADLOG - CALCULO EM MASSA-->
      <!--193	JAKLAYNE JOIAS-->
      <!--177	JAMEF - TESTE-->
      <!--39	KUICK-->
      <!--197	Lab. Globo-->
      <!--190	Lab. Globo - Port. 344-->
      <!--259	LELLO PRINT-->
      <!--278	LELLO PRINT - AÉREO-->
      <!--36	LINHA BRANCA-->
      <!--174	LOJAS IM-->
      <!--206	LOJAS MINATEL-->
      <!--225	LOJAS MINATEL - LINHA BRANCA-->
      <!--61	LOTAÇÃO BAÚ-->
      <!--11	LOTAÇÃO CARRETA TOCO-->
      <!--12	LOTAÇÃO CARRETA TRUCADA-->
      <!--57	LOTAÇÃO GERAL-->
      <!--10	LOTAÇÃO TRUCK-->
      <!--48	M GERAIS - "ACESSÓRIOS"-->
      <!--52	M GERAIS - "LINHA BRANCA"-->
      <!--168	MACROLUB - B2B-->
      <!--279	MACROLUB - B2C-->
      <!--270	MACROLUB RELATÓRIO-->
      <!--251	MAIFREDO-->
      <!--144	MANDAE-->
      <!--234	MANHATTAN-->
      <!--239	MAPEL-->
      <!--241	MAPEL COMPRAS-->
      <!--35	MASCOTE-->
      <!--216	MELHOR GATEWAY DO MERCADO-->
      <!--276	men first jadlog-->
      <!--199	MENFIRST-->
      <!--29	MERCADO PET-->
      <!--2	METAIS LEVES-->
      <!--3	METAIS PESADOS-->
      <!--6	MOVELARIA-->
      <!--248	MTR-->
      <!--182	Neve-->
      <!--188	NIM-->
      <!--202	Nutri Imports-->
      <!--222	OCEANS-->
      <!--201	OFFICE TOTAL - B2B-->
      <!--220	OFFICE TOTAL - COMPRAS-->
      <!--255	ONCOVIT - SORO-->
      <!--60	ONCOVIT AÉREO-->
      <!--204	Oncovit Carga Seca-->
      <!--194	Oncovit E-commerce-->
      <!--250	ONCOVIT EXPRESSO-->
      <!--59	ONCOVIT RODOVIÁRIO-->
      <!--33	ORGÂNICOS-->
      <!--119	PERFIL - CIF E FOB FRACIONADO-->
      <!--65	PERFIL ACESSÓRIOS-->
      <!--113	Perfil Lot Carreta Cascavel-->
      <!--112	Perfil Lot Carreta CE-->
      <!--74	Perfil Lot Carreta Centro-Oeste-->
      <!--104	Perfil Lot Carreta MG-->
      <!--106	Perfil Lot Carreta Nordeste-->
      <!--103	Perfil Lot Carreta SP-->
      <!--105	Perfil Lot Carreta Sul-->
      <!--115	Perfil Lot Truck BA-->
      <!--111	Perfil Lot Truck CE-->
      <!--107	Perfil Lot Truck Centro-Oeste-->
      <!--114	Perfil Lot Truck MG-->
      <!--110	Perfil Lot Truck Nordeste-->
      <!--108	Perfil Lot Truck SP-->
      <!--109	Perfil Lot Truck Sul-->
      <!--116	Perfil Lot Truck Teresina-->
      <!--56	PERFIL LOTAÇÃO-->
      <!--4	PERFILADOS DE ALUMÍNIO 6m-->
      <!--64	PLACAS DO BRASIL-->
      <!--179	PLASVIT-->
      <!--229	PROLICITANTE-->
      <!--245	PROLICITANTE - AR CONDICIONADO-->
      <!--246	PROLICITANTE - ATÉ 30 KG-->
      <!--242	PROLICITANTE - LINHA BRANCA-->
      <!--240	QUALIMAGE-->
      <!--80	REALCE-TECIDOS-->
      <!--280	REDESPACHO ARTMENTO-->
      <!--264	RELATÓRIO ARELL-->
      <!--269	relatorio azul-->
      <!--268	RELATÓRIO TECMAR-->
      <!--261	Relatório Transp.-->
      <!--221	Relatórios-->
      <!--18	REVESTIMENTOS-->
      <!--217	REZZOLUT-->
      <!--218	REZZOLUT - QUÍMICO-->
      <!--78	Rodorica-->
      <!--76	SALADA SHOP-->
      <!--81	SANCHES BABY-->
      <!--40	SANTOS DISTRIBUIDORA-->
      <!--166	SEGMENTO FRETE EM MASSA-->
      <!--50	SEGUIMENTO TESTE-->
      <!--228	SHOPTAN-->
      <!--207	SIPOLATTI-->
      <!--236	SIPOLATTI ACESSÓRIOS-->
      <!--233	SIPOLATTI COLCHOES-->
      <!--231	SIPOLATTI LINHA BRANCA-->
      <!--232	SIPOLATTI LINHA MARROM-->
      <!--70	SPECIALIZED-->
      <!--208	SUPERCOMMERCE-->
      <!--137	SUPERCOMMERCE SIMULAÇÕES-->
      <!--153	SUPERCOMMERCE-OFICIAL-->
      <!--43	SUPERFOODS-->
      <!--38	SUPRIMENTOS NÁUTICOS-->
      <!--27	SUSPENSO 13-27-->
      <!--23	SUSPENSO 15-23-->
      <!--25	SUSPENSO 17-25-->
      <!--21	SUSPENSO 9-21-->
      <!--180	TABELAS AVULSAS - VTEX-->
      <!--75	TAGIA-->
      <!--140	TARPONN-->
      <!--175	TARPONN - AÉREO-->
      <!--129	TARUGOS, LINGOTES/SUCATA - METAIS-->
      <!--184	TECH SHOP-->
      <!--16	TEMPORARIO-->
      <!--159	TESTE - VTEX (NAO USAR)-->
      <!--252	TESTE TABELAS-->
      <!--42	TESTE TDE-->
      <!--79	TNT-TOTAL-CONCILIAÇÃO-->
      <!--37	TOTAL FILTROS-->
      <!--130	TRANSFERÊNCIA PORTO X FÁBRICA-->
      <!--146	TRANSP MOVIMENTE-->
      <!--127	TRUCK | ALIMENTO-->
      <!--256	UNIVERSO DOS CAMINHÕES-->
      <!--223	UP PARTNERS-->
      <!--186	Usaflex-->
      <!--45	VIABEM-->
      <!--49	VILA ERVAS-->
      <!--205	Vila Vitória E-commerce-->
      <!--209	vitor-->
      <!--126	VTEX - GERAR TABELAS-->
      <!--172	VTEX - MACROLUB ORIGEM ES-->
      <!--171	VTEX - MACROLUB ORIGEM MG-->
      <!--173	VTEX - MACROLUB ORIGEM RJ-->
      <!--178	VTEX COLIBRI-->
      <!--212	WELOGIK-->
      <!--72	WM - LOTAÇÃO-->
      <!--73	WM - RESIAK-->
      <!--237	WORKLINE-->
      <!--86	xx-->
      <!--88	xxx-->
      <!--87	xxxxx-->
      <!--83	xxxxxx-->
      <!--163	YAMA-->
      <!--20	z ECONOCARGO-->
      <!--123	ZARB-->
      <!--124	ZARB - SUPERMERCADOS-->


      <!--            &ndash;&gt;-->
      <!--          </select>-->

      <!--        </div>-->
      <!--      </div>-->



      <div v-if="!loadingTransp && transpData">
        <p class="mb-2">
          Transportadora Atual
        </p>
        <router-link :to="`/tiposopera/list`" target="_blank">
          <p class="mb-2">
            Código:
            <span class="text-primary"> {{ transpData.codigo }} </span>
          </p>

          <p class="mb-2">
            Nome:
            <span class="text-primary"> {{ transpData.nome }} </span>
          </p>
        </router-link>

        <div class="table-responsive" v-if="ultPedsData">
          <table class="table table-centered table-nowrap">
            <thead>
            <tr>
              <th scope="col">Últimos Pedidos</th>
              <th scope="col" class="text-end">Data</th>
              <th scope="col" class="text-end">Valor (R$)</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="data in ultPedsData" :key="data.id">
              <td>
                <router-link :to="`/orcamento/editar/${data.id}`" target="_blank">
                  <div>
                    <h5 class="text-truncate font-size-14">
                      {{ data.codigo }}
                    </h5>
                  </div>
                </router-link>
              </td>
              <td class="text-end">{{ formatDateTime(data.created_at) }}</td>
              <td class="text-end">{{ formatDecimal(data.valorliq) }}</td>
            </tr>
            <tr>
              <td colspan="2">
                <h6 class="m-0 text-end">Valor Total Pedidos:</h6>
              </td>
              <td class="text-end">R$ {{ formatDecimal(somaPedidosCli) }}</td>
            </tr>
            <tr>
              <td colspan="2">
                <h6 class="m-0 font-size-14  text-end">Ticket Médio:</h6>
              </td>
              <td class="font-size-14 text-end">R$ {{ formatDecimal(somaPedidosCli / 3) }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalTransp = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confirmarTransp">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>

    <b-modal size="lg"
             :title="orctoItemData.id != null ? `Editar Item do Orçamento (${orctoItemData.id})` : 'Criar Novo Item no Orçamento'"
             v-model="showModalOrctoItem" @shown="focusProdOrctoItem" hide-footer>

      <div class="col-md-12">
        <div class="mb-3">
          <span>Selecionar Novo Produto</span>
          <multiselect id="prodorctoitem" ref="focusThis" @search-change="pesqOrctoItem" @select="escolheuOrctoItem"
                       v-model="orctoItemData.produto" placeholder="Pesquisar novo produto" :options="dtlistPesqOrctoItem"
                       :searchable="true" label="descricao" class="multiselect-size" track-by="descrcodigo" value-prop="codigo">
            <template #option="slotProps" v-if="dtlistPesqOrctoItem">
              <div class="row" style="min-width: 100%;">

                <div style="min-width: 100%;">
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4">
                    {{ slotProps.option.unidade }}
                  </span>
                  <span class="float-end text-warning">
                    R$ {{ formatDecimal(slotProps.option.preco) }}
                  </span>
                </div>

                <div class="col-12">
                  <span class="mt-5 font-size-15">
                    {{ slotProps.option.descricao }}
                  </span>
                  <span class="float-end">
                    <!--                    R$ {{ formatDecimal(slotProps.option.preco) }}-->

                  </span>
                </div>

                <div class="align-items-end text-end align-content-end float-end">
                  <div v-if="!slotProps.option.img1" class="avatar-xs">
                    <span class="avatar-title rounded-circle">{{ slotProps.option.id }}</span>
                  </div>
                  <div v-if="slotProps.option.img1">
                    <img class="rounded-circle avatar-xs" :src="slotProps.option.img1" alt />
                  </div>

                  <span class="float-end ">
                    <span v-if="slotProps.option.saldo > 0"
                          class="avatar-title rounded-circle bg-success avatar-xs p-1">
                      <span class="">{{ formatInteger(slotProps.option.saldo) }}</span>
                    </span>

                    <span v-else class="avatar-title rounded-circle bg-danger avatar-xs p-1">
                      <span class="">{{ formatDecimal(slotProps.option.preco) }}</span>
                    </span>

                  </span>
                </div>


              </div>
            </template>
          </multiselect>
        </div>
      </div>
      <div class="row" v-if="loadingOrctoItem">
        <div class="col-12 text-center">
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
        </div>
      </div>

      <div v-if="!loadingOrctoItem && orctoItemData && orctoItemData.descprod">

        <router-link :to="`/produto/editar/${orctoItemData.produto_id}`" target="_blank">
          <div class="row">

            <div class="col-lg-6">
              <div class="card mini-stats-wid">
                <div class="card-body" style="min-height: 160px;">
                  <div class="d-flex flex-wrap">
                    <div class="me-2">
                      <p class="text-muted mb-2">{{ orctoItemData.descprod }}</p>
                      <h5 class="mb-0">saldo: {{ formatInteger(orctoItemData.saldo) }} ({{ orctoItemData.und }})</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-sm ms-auto" v-if="!orctoItemData.img1">
                        <div class="avatar-title bg-light rounded-circle text-primary font-size-20">
                          <i class="bx bx-camera-off"></i>
                        </div>
                      </div>

                      <div class="avatar-sm ms-auto" v-if="orctoItemData.img1">
                        <div class="avatar-title bg-light rounded-circle text-primary font-size-20">
                          <img class="rounded-circle avatar-xs" :src="orctoItemData.img1" alt />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-6">
              <div class="card mini-stats-wid">
                <div class="card-body" style="min-height: 155px;">
                  <div class="d-flex flex-wrap">
                    <div class="me-2">
                      <span class="text-muted mb-2">Código: </span> <span class="text-info"> {{ orctoItemData.produto }}
                      </span>
                    </div>
                    <div class="">
                      <p class="text-muted mb-2">Preço de Tabela (Bruto)</p>
                      <h5 class="mb-0 mt-3">R$ {{ formatDecimal(orctoItemData.vlrunitbrt) }}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-light rounded-circle text-primary font-size-20">
                        <i class="bx bx-money"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


          </div>
        </router-link>



        <form class="needs-validation" @submit.prevent="confOrctoItem">
          <div class="row">

            <div class="col-md-6">
              <div class="mb-3">
                <label for="vlrunitliq">Valor Unitário</label>
                <input id="vlrunitliq" v-model="orctoItemData.vlrunitliq" type="number" class="form-control text-end"
                       placeholder="Valor unitário líquido"
                       :class="{ 'is-invalid': submitOrctoItem && v$.orctoItemData.vlrunitliq.$error, }" />
                <div v-if="submitOrctoItem && v$.orctoItemData.vlrunitliq.$error" class="invalid-feedback">
                  <span v-if="v$.orctoItemData.vlrunitliq.required.$message">{{
                      v$.orctoItemData.vlrunitliq.required.$message }}</span>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="mb-3">
                <label for="qtd">Quantidade</label>
                <input id="qtd" v-model="orctoItemData.qtd" type="number" class="form-control text-end"
                       placeholder="Quantidade" :class="{ 'is-invalid': submitOrctoItem && v$.orctoItemData.qtd.$error, }" />
                <div v-if="submitOrctoItem && v$.orctoItemData.qtd.$error" class="invalid-feedback">
                  <span v-if="v$.orctoItemData.qtd.required.$message">{{ v$.orctoItemData.qtd.required.$message
                    }}</span>
                </div>
              </div>
            </div>


            <div class="col-md-3">
              <div class="mb-3">
                <label for="desconto">R$ Desconto UNITÁRIO</label>
                <input id="desconto" v-model="orctoItemData.desconto" type="number" class="form-control text-end"
                       placeholder="Desconto" />
              </div>
            </div>
          </div>

        </form>



        <div class="row text-end" v-if="messageValidacaoItem !== ''">

          <div class="col-md-12">
            <span class="text-danger"> {{ messageValidacaoItem }} * </span>
          </div>

        </div>


        <div class="row">

          <div class="text-end mt-5">
            <b-button variant="light" @click="showModalOrctoItem = false">
              <i class="bx bx-block font-size-16 align-middle me-2"></i>
              Cancelar
            </b-button>
            <b-button variant="success" class="ms-1" @click="confOrctoItem" :disabled="messageValidacaoItem !== ''">
              <!--confOrctoItem | orctoitemUpdate-->
              <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
              Confirmar
            </b-button>
          </div>

        </div>

      </div>

    </b-modal>

    <b-modal title="Detalhes Pagamento" v-model="showModalCondPgto" centered hide-footer>

      <div class="col-md-12 mt-2">
        <div class="mb-3">
          <span>Selecionar Nova Forma de Pagamento</span>

          <multiselect id="formapgto" @search-change="pesqFormaPgto" @select="escolheuFormaPgto"
                       v-model="orctoData.formapgto" placeholder="Pesquisar forma de pagamento" :options="dtListPesqFormaPgto"
                       :searchable="true" label="descricao" track-by="descricao" value-prop="codigo">
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4">

                  </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>
                <span class="mx-4">
                </span>
                <span class="mx-4">
                </span>
                <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at)
                  }} </div>

              </div>
            </template>
          </multiselect>

        </div>
      </div>

      <div class="col-md-12 mt-2">
        <div class="mb-3">
          <span>Selecionar Nova Condição de Pagamento</span>

          <multiselect id="condpgto" @search-change="pesqCondPgto" @select="escolheuCondPgto"
                       v-model="orctoData.condpgto" placeholder="Pesquisar condição de pagamento" :options="dtListPesqCondPgto"
                       :searchable="true" label="descricao" track-by="descricao" value-prop="codigo">
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4">

                  </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>

                <span class="mx-4">

                </span>
                <span class="mx-4">

                </span>
                <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at)
                  }} </div>

              </div>
            </template>
          </multiselect>

        </div>
      </div>

      <div class="row" v-if="loadingCondPgto">
        <div class="col-12 text-center">
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
        </div>
      </div>


      <div v-if="!loadingCondPgto && condPgtoData && formaPgtoData">




        <div class="mt-2">
          <p class="mb-2">
            Forma de Pagamento Atual
          </p>

          <p class="mb-2">
            Código:
            <span class="text-primary"> {{ formaPgtoData.codigo }} </span>
          </p>

          <p class="mb-2">
            Descrição:
            <span class="text-primary"> {{ formaPgtoData.descricao }} </span>
          </p>
        </div>


        <div class="mt-4">
          <p class="mb-2">
            Condição de Pagamento Atual
          </p>

          <p class="mb-2">
            Código:
            <span class="text-primary"> {{ condPgtoData.codigo }} </span>
          </p>

          <p class="mb-2">
            Descrição:
            <span class="text-primary"> {{ condPgtoData.descricao }} </span>
          </p>
        </div>




        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalCondPgto = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confirmarFormaPgto">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>

    <b-modal title="Alterar Data Orçamento" v-model="showModalDataOrcamento" centered hide-footer>

      <div class="col-md-12 mt-2">
        <div class="mb-3">
          <!-- <span>Selecionar Nova Data Orçamento</span> -->
          <div class="row">

            <div class="col-md-6">
              <div class="mb-3">
                <label for="novaDtOracamento">Selecionar Nova Data Orçamento</label>
                <input id="novaDtOracamento" v-model="orctoData.dtemissao" type="date" class="form-control" placeholder="Data Orçamento"
                       :class="{ 'is-invalid': submittedPeriodo && !dtIniFiltro, }" />
                <div v-if="submittedPeriodo && !dtIniFiltro" class="invalid-feedback">
                  <span>Campo data início obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-if="loadingCondPgto">
        <div class="col-12 text-center">
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
        </div>
      </div>


      <div v-if="!loadingCondPgto && condPgtoData && formaPgtoData">

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalCondPgto = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confirmarDataOrcamento">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>

    <b-modal size="xl" title="Cotação de Frete" v-model="showModalCotarFrete" centered hide-footer>
      <div class="col-md-12">



        <div class="row" v-if="loadingCotarFrete">
          <div class="col-12 text-center">
            <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
            </b-spinner>
            <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
            </b-spinner>
            <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
            </b-spinner>
          </div>
        </div>

        <div class="table-responsive" v-if="cotaFreteListData">
          <table class="table table-centered table-nowrap">
            <thead>
            <tr>
              <th scope="col">Ações</th>
              <th scope="col">TranspNome</th>
              <th scope="col" class="">Frete R$</th>
              <th scope="col" class="">Frete %</th>
              <th scope="col" class="">Frete KG</th>


              <th scope="col" class="text-end">PrazoDias</th>

              <th scope="col">TranspCNPJ</th>
              <th scope="col">TranspEmail</th>
              <th scope="col" class="text-end">Mov.Cot.ID</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="data in cotaFreteListData" :key="data.id">
              <td>
                <a href="javascript:void(0);" v-b-tooltip.hover class="action-icon text-info mx-2"
                   title="Definir valor orçamento frete" @click="escolherFrete(data.WSOut_Frete_Val)">
                  <i class="mdi mdi-check-outline font-size-18"></i>
                </a>
              </td>

              <td>
                {{ data.WSOut_Transp_Nome }}
              </td>

              <td class="text-end">
                <i class="bx bxs-dollar-circle font-size-18 bx-fade-right text-success" v-if="data.menorvalor"></i>
                {{ formatDecimal(data.WSOut_Frete_Val) }}
              </td>

              <td class="text-end">
                <i class="bx bxs-dollar-circle font-size-18 bx-fade-right text-success" v-if="data.menorvalor"></i>
                {{ formatDecimal((data.WSOut_Frete_Val / orctoData.valorliq) * 100) }}
              </td>

              <td class="text-end">
                <i class="bx bxs-dollar-circle font-size-18 bx-fade-right text-success" v-if="data.menorvalor"></i>
                {{ formatDecimal((data.WSOut_Frete_Val / orctoData.peso) * 100) }}
              </td>

              <!--              <td>-->
              <!--                <div>-->
              <!--                  <h5 class="text-truncate font-size-14">-->
              <!--                    {{ formatDateTime(data.WSOut_DataH) }}-->
              <!--                  </h5>-->
              <!--                </div>-->
              <!--              </td>-->

              <td class="text-end">
                <i class="bx bxs-calendar font-size-18 bx-fade-right text-info" v-if="data.menorprazo"></i>
                {{ data.WSOut_Prazo_Dias }}
              </td>

              <!--              <td class="text-end">-->
              <!--                {{ data.WSOut_Indic }}-->
              <!--              </td>-->
              <!--              <td class="text-end">-->
              <!--                {{ data.WSOut_MovCot_ID }}-->
              <!--              </td>-->
              <!--              <td class="text-end">-->
              <!--                {{ data.WSOut_MovSim_ID }}-->
              <!--              </td>-->
              <!--              <td>-->
              <!--                {{ data.WSOut_NotaS }}-->
              <!--              </td>-->

              <td>
                {{ data.WSOut_Transp_CNPJ }}
              </td>
              <td>
                {{ data.WSOut_Transp_Email }}
              </td>
              <td class="text-end">
                {{ data.WSOut_MovCot_ID }}
              </td>

            </tr>

            <!--            <tr>-->
            <!--              <td colspan="4">-->
            <!--                <h6 class="m-0 text-end">Quantidade Total Volumes:</h6>-->
            <!--              </td>-->
            <!--              <td class="text-end"> {{ formatDecimal(0.00) }}</td>-->
            <!--            </tr>-->

            <!--            <tr>-->
            <!--              <td colspan="4">-->
            <!--                <h6 class="m-0 font-size-14  text-end">Peso Total Volumes:</h6>-->
            <!--              </td>-->
            <!--              <td class="font-size-14 text-end"> {{ formatDecimal(0.00) }}</td>-->
            <!--            </tr>-->

            </tbody>
          </table>
        </div>


        <!--        <div class="mb-3">-->
        <!--          <label for="obs">Observações do Pedido</label>-->
        <!--          <textarea-->
        <!--              id="obs"-->
        <!--              v-model="orctoData.obs"-->
        <!--              type="text"-->
        <!--              rows="3"-->
        <!--              class="form-control"-->
        <!--              placeholder="Observações do Pedido"/>-->
        <!--        </div>-->


        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalCotarFrete = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="showModalCotarFrete = false">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>

    <b-modal size="lg"
             :title="orctoFinanData.id != null ? `Editar Pagamento do Orçamento (${orctoFinanData.id})` : 'Criar Novo Pagamento no Orçamento'"
             v-model="showModalOrctoFinan" hide-footer>

      <div>

        <form class="needs-validation" @submit.prevent="confOrctoFinanc">
          <div class="row">

            <div class="col-md-6 mt-2">
              <div class="mb-3">
                <span>Forma de Pagamento</span>
                <multiselect id="formapgto" @search-change="pesqFormaPgto" @select="escolheuFormaPgto"
                             v-model="orctoFinanData.formapgto" placeholder="Pesquisar forma de pagamento"
                             :options="dtListPesqFormaPgto" :searchable="true" label="descricao" track-by="descricao"
                             :style="submitOrctoFinanc && !orctoFinanData.formapgto ? 'border: 1px solid #f86c6b !important;' : ''"
                             value-prop="codigo">
                  <template #option="slotProps">
                    <div class="row">
                      <div>
                        <span class="text-info">
                          {{ slotProps.option.codigo }}
                        </span>
                        <span class="mx-4"> </span>
                      </div>
                      <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>
                      <span class="mx-4"></span>
                      <span class="mx-4"></span>
                      <div class="align-items-end text-end align-content-end">{{
                          formatDateTime(slotProps.option.created_at) }} </div>
                    </div>
                  </template>
                </multiselect>
                <div v-if="submitOrctoFinanc && !orctoFinanData.formapgto">
                  <span class="text-danger font-size-11">Campo Forma de Pagamento obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>


            <div class="col-md-6">
              <div class="mb-3">
                <label for="valor">Valor</label>
                <input id="valor" v-model="orctoFinanData.valor" type="number" class="form-control text-end"
                       placeholder="Valor" :class="{ 'is-invalid': submitOrctoFinanc && !orctoFinanData.valor }" />
                <div v-if="submitOrctoFinanc && !orctoFinanData.valor" class="invalid-feedback">
                  <span> Campo valor obrigatório, favor preencher. </span>
                </div>
              </div>
            </div>

          </div>

          <div class="row">
            <div class="mb-3">
              <label for="obs">Observações</label>
              <textarea id="obs" v-model="orctoFinanData.obs" type="text" rows="3" class="form-control"
                        placeholder="Observações" />
            </div>
          </div>

        </form>

        <div class="row text-end" v-if="messageValidacaoItem !== ''">
          <div class="col-md-12">
            <span class="text-danger"> {{ messageValidacaoItem }} * </span>
          </div>
        </div>


        <div class="row">

          <div class="text-end mt-5">
            <b-button variant="light" @click="showModalOrctoFinan = false">
              <i class="bx bx-block font-size-16 align-middle me-2"></i>
              Cancelar
            </b-button>

            <b-button variant="outline-danger" class="ms-1" @click="excluirFinanc" v-if="orctoFinanData.id > 0">
              <i class="bx bx-trash font-size-16 align-middle me-2"></i>
              Excluir Lançamento
            </b-button>


            <b-button variant="success" class="ms-1" @click="confOrctoFinanc" :disabled="messageValidacaoItem !== ''">
              <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
              Confirmar
            </b-button>


          </div>

        </div>

      </div>

    </b-modal>

  </Layout>
</template>

<style>
.multiselect-size {
  --ms-max-height: 500px;
}
</style>
